/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ArticleFilter = {
  AND?: Array<ArticleFilter | null> | null;
  OR?: Array<ArticleFilter | null> | null;
  author?: cfAuthorNestedFilter | null;
  author_exists?: boolean | null;
  breeds?: cfBreedNestedFilter | null;
  breedsCollection_exists?: boolean | null;
  category?: cfTopicNestedFilter | null;
  category_exists?: boolean | null;
  content_contains?: string | null;
  content_exists?: boolean | null;
  content_not_contains?: string | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  fromBirthWeek?: number | null;
  fromBirthWeek_exists?: boolean | null;
  fromBirthWeek_gt?: number | null;
  fromBirthWeek_gte?: number | null;
  fromBirthWeek_in?: Array<number | null> | null;
  fromBirthWeek_lt?: number | null;
  fromBirthWeek_lte?: number | null;
  fromBirthWeek_not?: number | null;
  fromBirthWeek_not_in?: Array<number | null> | null;
  mainImage_exists?: boolean | null;
  metadataTitle?: string | null;
  metadataTitle_contains?: string | null;
  metadataTitle_exists?: boolean | null;
  metadataTitle_in?: Array<string | null> | null;
  metadataTitle_not?: string | null;
  metadataTitle_not_contains?: string | null;
  metadataTitle_not_in?: Array<string | null> | null;
  org_contains_all?: Array<string | null> | null;
  org_contains_none?: Array<string | null> | null;
  org_contains_some?: Array<string | null> | null;
  org_exists?: boolean | null;
  readTime?: number | null;
  readTime_exists?: boolean | null;
  readTime_gt?: number | null;
  readTime_gte?: number | null;
  readTime_in?: Array<number | null> | null;
  readTime_lt?: number | null;
  readTime_lte?: number | null;
  readTime_not?: number | null;
  readTime_not_in?: Array<number | null> | null;
  relatedArticles?: cfArticleNestedFilter | null;
  relatedArticlesCollection_exists?: boolean | null;
  seoDescription?: string | null;
  seoDescription_contains?: string | null;
  seoDescription_exists?: boolean | null;
  seoDescription_in?: Array<string | null> | null;
  seoDescription_not?: string | null;
  seoDescription_not_contains?: string | null;
  seoDescription_not_in?: Array<string | null> | null;
  shortText?: string | null;
  shortText_contains?: string | null;
  shortText_exists?: boolean | null;
  shortText_in?: Array<string | null> | null;
  shortText_not?: string | null;
  shortText_not_contains?: string | null;
  shortText_not_in?: Array<string | null> | null;
  species?: cfSpeciesNestedFilter | null;
  species_exists?: boolean | null;
  sys?: SysFilter | null;
  title?: string | null;
  title_contains?: string | null;
  title_exists?: boolean | null;
  title_in?: Array<string | null> | null;
  title_not?: string | null;
  title_not_contains?: string | null;
  title_not_in?: Array<string | null> | null;
  toBirthWeek?: number | null;
  toBirthWeek_exists?: boolean | null;
  toBirthWeek_gt?: number | null;
  toBirthWeek_gte?: number | null;
  toBirthWeek_in?: Array<number | null> | null;
  toBirthWeek_lt?: number | null;
  toBirthWeek_lte?: number | null;
  toBirthWeek_not?: number | null;
  toBirthWeek_not_in?: Array<number | null> | null;
  topics?: cfTopicNestedFilter | null;
  topicsCollection_exists?: boolean | null;
  uri?: string | null;
  uri_contains?: string | null;
  uri_exists?: boolean | null;
  uri_in?: Array<string | null> | null;
  uri_not?: string | null;
  uri_not_contains?: string | null;
  uri_not_in?: Array<string | null> | null;
  video?: cfVideoNestedFilter | null;
  video_exists?: boolean | null;
};

export enum BreedType {
  cutemix = 'cutemix',
  mixed = 'mixed',
  single = 'single',
  unknown = 'unknown'
}

export type ChangePaymentMethodInput = {
  paymentMethod: PaymentMethodEnum;
  paymentMethodId: string;
};

export type ChangePayoutMethodInput = {
  payoutMethod?: PayoutMethodEnum | null;
  payoutMethodId?: string | null;
};

export type ChargeInput = {
  paymentCandidateId: string;
};

export type CheckMultiBindInput = {
  draftId: string;
};

export type ClientDraftAddressInput = {
  city?: string | null;
  line1?: string | null;
  line2?: string | null;
  zip: string;
};

export type ClientDraftInput = {
  acceptedAssumptions?: boolean | null;
  acceptedDeclarations?: boolean | null;
  address?: ClientDraftAddressInput | null;
  allowMarketing?: boolean | null;
  birthdate?: string | null;
  email?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  region?: string | null;
  ssn?: any;
};

export type CompleteSetupPaymentMethodInput = {
  checkoutSessionId?: string | null;
  paymentMethod?: PaymentMethodEnum | null;
  paymentMethodSetupId?: string | null;
  payoutMethod?: PayoutMethodEnum | null;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all?: Array<string | null> | null;
  id_contains_none?: Array<string | null> | null;
  id_contains_some?: Array<string | null> | null;
};

export type ContentfulMetadataConceptsFilter = {
  descendants?: ContentfulMetadataConceptsDescendantsFilter | null;
  id_contains_all?: Array<string | null> | null;
  id_contains_none?: Array<string | null> | null;
  id_contains_some?: Array<string | null> | null;
};

export type ContentfulMetadataFilter = {
  concepts?: ContentfulMetadataConceptsFilter | null;
  concepts_exists?: boolean | null;
  tags?: ContentfulMetadataTagsFilter | null;
  tags_exists?: boolean | null;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all?: Array<string | null> | null;
  id_contains_none?: Array<string | null> | null;
  id_contains_some?: Array<string | null> | null;
};

export enum DiscountApplicationType {
  flat = 'flat',
  percent = 'percent'
}

export enum DiscountType {
  age = 'age',
  breeder = 'breeder',
  marketing = 'marketing',
  multipet = 'multipet',
  points = 'points',
  referral = 'referral'
}

export type FaqItemFilter = {
  AND?: Array<FaqItemFilter | null> | null;
  OR?: Array<FaqItemFilter | null> | null;
  answer_contains?: string | null;
  answer_exists?: boolean | null;
  answer_not_contains?: string | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  name?: string | null;
  name_contains?: string | null;
  name_exists?: boolean | null;
  name_in?: Array<string | null> | null;
  name_not?: string | null;
  name_not_contains?: string | null;
  name_not_in?: Array<string | null> | null;
  question?: string | null;
  question_contains?: string | null;
  question_exists?: boolean | null;
  question_in?: Array<string | null> | null;
  question_not?: string | null;
  question_not_contains?: string | null;
  question_not_in?: Array<string | null> | null;
  sys?: SysFilter | null;
};

export type GetBreedsInput = {
  limit?: number | null;
  search?: string | null;
  species?: SpeciesEnum | null;
};

export type InitMultiBindInput = {
  data?: PaymentMethodData | null;
  draftId: string;
  lassiePlus?: LassiePlusSignupInput | null;
  paymentMethod: PaymentMethodEnum;
};

export type IsSignaturePresentInput = {
  binary?: string | null;
};

export type LassiePlusSignupInput = {
  interval?: string | null;
  productSlug: string;
  selectedPolicyDraftIds?: Array<string> | null;
  startDate?: string | null;
};

export enum LifeCoverSeller {
  breeder = 'breeder',
  private = 'private',
  shelter = 'shelter'
}

export enum MixedBreedHeight {
  height_0_45 = 'height_0_45',
  height_45_plus = 'height_45_plus'
}

export enum MixedBreedWeight {
  weight_0_10 = 'weight_0_10',
  weight_10_20 = 'weight_10_20',
  weight_20_30 = 'weight_20_30',
  weight_30_plus = 'weight_30_plus'
}

export type PaymentMethodData = {
  iban?: string | null;
  returnUrl?: string | null;
  type?: string | null;
};

export enum PaymentMethodEnum {
  STRIPE = 'STRIPE',
  TRUSTLY = 'TRUSTLY',
  TRUSTLY_MDD = 'TRUSTLY_MDD'
}

export enum PaymentTransactionStatus {
  Disputed = 'Disputed',
  Failed = 'Failed',
  Incomplete = 'Incomplete',
  Pending = 'Pending',
  PendingSucceeded = 'PendingSucceeded',
  Succeded = 'Succeded'
}

export enum PayoutMethodEnum {
  ATLAR = 'ATLAR',
  PAYPAL = 'PAYPAL',
  SWISH = 'SWISH',
  TRUSTLY = 'TRUSTLY',
  TRUSTLY_MDD = 'TRUSTLY_MDD'
}

export type PolicyDraftBreedDataInput = {
  breedIds: Array<string>;
  displayNames: Array<string>;
  mixedBreedHeight?: MixedBreedHeight | null;
  mixedBreedWeight?: MixedBreedWeight | null;
  type: BreedType;
};

export type PolicyDraftInput = {
  _id: string;
  billingDay?: number | null;
  billingInterval: number;
  deductible: number;
  effectiveDate: string;
  limit: number;
  metadata: PolicyDraftMetadataInput;
  productName: ProductEnum;
  ratingsData: PolicyDraftRatingsDataInput;
  selectedPlan: string;
};

export type PolicyDraftMetadataInput = {
  analyticsId?: string | null;
  animalId?: string | null;
  attribution?: string | null;
  cancelPreviousInsurance?: boolean | null;
  chipNumber?: string | null;
  compare?: boolean | null;
  customerSignature?: string | null;
  discount?: string | null;
  draftAnimalId?: string | null;
  eurobonusMemberId?: string | null;
  healthHistory?: string | null;
  imported?: string | null;
  insuranceHistory?: string | null;
  lunarMemberId?: string | null;
  microchipped?: string | null;
  partner?: string | null;
  previousInsurance?: string | null;
  purchasePrice?: number | null;
  signupArm?: string | null;
};

export type PolicyDraftRatingsDataInput = {
  access?: string | null;
  birthday: string;
  breed: string;
  breedData?: PolicyDraftBreedDataInput | null;
  breedersAddOn?: boolean | null;
  clientBirthdate?: string | null;
  copay?: number | null;
  liabilityBestAddOn?: boolean | null;
  liabilityRentedAddOn?: boolean | null;
  liabilitySosAddOn?: boolean | null;
  lifeCoverSeller?: LifeCoverSeller | null;
  lifeLimit?: number | null;
  lifeUtilityAddOn?: string | null;
  name: string;
  preexistingConditions?: boolean | null;
  preventiveCareAddOnLimit?: number | null;
  sex: string;
};

export enum ProductEnum {
  cat = 'cat',
  dog = 'dog',
  liability = 'liability'
}

export type RemovePaymentMethodInput = {
  paymentMethod: PaymentMethodEnum;
  paymentMethodId: string;
};

export type ResumeDraftInput = {
  _id: string;
};

export type SetUkPayoutAccountInput = {
  accountNumber: string;
  sortCode: string;
};

export type SetupPaymentMethodInput = {
  data?: PaymentMethodData | null;
  paymentMethod: PaymentMethodEnum;
};

export enum SpeciesEnum {
  cat = 'cat',
  dog = 'dog'
}

export type SubmitWithdrawalRequestInput = {
  customerEmail: string;
  customerName: string;
  customerSsn?: string | null;
  policyNumbers: string;
};

export type SysFilter = {
  firstPublishedAt?: any;
  firstPublishedAt_exists?: boolean | null;
  firstPublishedAt_gt?: any;
  firstPublishedAt_gte?: any;
  firstPublishedAt_in?: Array<any> | null;
  firstPublishedAt_lt?: any;
  firstPublishedAt_lte?: any;
  firstPublishedAt_not?: any;
  firstPublishedAt_not_in?: Array<any> | null;
  id?: string | null;
  id_contains?: string | null;
  id_exists?: boolean | null;
  id_in?: Array<string | null> | null;
  id_not?: string | null;
  id_not_contains?: string | null;
  id_not_in?: Array<string | null> | null;
  publishedAt?: any;
  publishedAt_exists?: boolean | null;
  publishedAt_gt?: any;
  publishedAt_gte?: any;
  publishedAt_in?: Array<any> | null;
  publishedAt_lt?: any;
  publishedAt_lte?: any;
  publishedAt_not?: any;
  publishedAt_not_in?: Array<any> | null;
  publishedVersion?: number | null;
  publishedVersion_exists?: boolean | null;
  publishedVersion_gt?: number | null;
  publishedVersion_gte?: number | null;
  publishedVersion_in?: Array<number | null> | null;
  publishedVersion_lt?: number | null;
  publishedVersion_lte?: number | null;
  publishedVersion_not?: number | null;
  publishedVersion_not_in?: Array<number | null> | null;
};

export type TopicFilter = {
  AND?: Array<TopicFilter | null> | null;
  OR?: Array<TopicFilter | null> | null;
  color?: string | null;
  color_contains?: string | null;
  color_exists?: boolean | null;
  color_in?: Array<string | null> | null;
  color_not?: string | null;
  color_not_contains?: string | null;
  color_not_in?: Array<string | null> | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  icon?: string | null;
  iconBackground?: string | null;
  iconBackground_contains?: string | null;
  iconBackground_exists?: boolean | null;
  iconBackground_in?: Array<string | null> | null;
  iconBackground_not?: string | null;
  iconBackground_not_contains?: string | null;
  iconBackground_not_in?: Array<string | null> | null;
  iconColor?: string | null;
  iconColor_contains?: string | null;
  iconColor_exists?: boolean | null;
  iconColor_in?: Array<string | null> | null;
  iconColor_not?: string | null;
  iconColor_not_contains?: string | null;
  iconColor_not_in?: Array<string | null> | null;
  icon_contains?: string | null;
  icon_exists?: boolean | null;
  icon_in?: Array<string | null> | null;
  icon_not?: string | null;
  icon_not_contains?: string | null;
  icon_not_in?: Array<string | null> | null;
  image_exists?: boolean | null;
  name?: string | null;
  name_contains?: string | null;
  name_exists?: boolean | null;
  name_in?: Array<string | null> | null;
  name_not?: string | null;
  name_not_contains?: string | null;
  name_not_in?: Array<string | null> | null;
  species?: cfSpeciesNestedFilter | null;
  species_exists?: boolean | null;
  sys?: SysFilter | null;
  uri?: string | null;
  uri_contains?: string | null;
  uri_exists?: boolean | null;
  uri_in?: Array<string | null> | null;
  uri_not?: string | null;
  uri_not_contains?: string | null;
  uri_not_in?: Array<string | null> | null;
};

export type UpsertDraftInput = {
  _id?: string | null;
  clientInput?: ClientDraftInput | null;
  insuredPetCount?: number | null;
  policyInputs?: Array<PolicyDraftInput> | null;
};

export type cfArticleNestedFilter = {
  AND?: Array<cfArticleNestedFilter | null> | null;
  OR?: Array<cfArticleNestedFilter | null> | null;
  author_exists?: boolean | null;
  breedsCollection_exists?: boolean | null;
  category_exists?: boolean | null;
  content_contains?: string | null;
  content_exists?: boolean | null;
  content_not_contains?: string | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  fromBirthWeek?: number | null;
  fromBirthWeek_exists?: boolean | null;
  fromBirthWeek_gt?: number | null;
  fromBirthWeek_gte?: number | null;
  fromBirthWeek_in?: Array<number | null> | null;
  fromBirthWeek_lt?: number | null;
  fromBirthWeek_lte?: number | null;
  fromBirthWeek_not?: number | null;
  fromBirthWeek_not_in?: Array<number | null> | null;
  mainImage_exists?: boolean | null;
  metadataTitle?: string | null;
  metadataTitle_contains?: string | null;
  metadataTitle_exists?: boolean | null;
  metadataTitle_in?: Array<string | null> | null;
  metadataTitle_not?: string | null;
  metadataTitle_not_contains?: string | null;
  metadataTitle_not_in?: Array<string | null> | null;
  org_contains_all?: Array<string | null> | null;
  org_contains_none?: Array<string | null> | null;
  org_contains_some?: Array<string | null> | null;
  org_exists?: boolean | null;
  readTime?: number | null;
  readTime_exists?: boolean | null;
  readTime_gt?: number | null;
  readTime_gte?: number | null;
  readTime_in?: Array<number | null> | null;
  readTime_lt?: number | null;
  readTime_lte?: number | null;
  readTime_not?: number | null;
  readTime_not_in?: Array<number | null> | null;
  relatedArticlesCollection_exists?: boolean | null;
  seoDescription?: string | null;
  seoDescription_contains?: string | null;
  seoDescription_exists?: boolean | null;
  seoDescription_in?: Array<string | null> | null;
  seoDescription_not?: string | null;
  seoDescription_not_contains?: string | null;
  seoDescription_not_in?: Array<string | null> | null;
  shortText?: string | null;
  shortText_contains?: string | null;
  shortText_exists?: boolean | null;
  shortText_in?: Array<string | null> | null;
  shortText_not?: string | null;
  shortText_not_contains?: string | null;
  shortText_not_in?: Array<string | null> | null;
  species_exists?: boolean | null;
  sys?: SysFilter | null;
  title?: string | null;
  title_contains?: string | null;
  title_exists?: boolean | null;
  title_in?: Array<string | null> | null;
  title_not?: string | null;
  title_not_contains?: string | null;
  title_not_in?: Array<string | null> | null;
  toBirthWeek?: number | null;
  toBirthWeek_exists?: boolean | null;
  toBirthWeek_gt?: number | null;
  toBirthWeek_gte?: number | null;
  toBirthWeek_in?: Array<number | null> | null;
  toBirthWeek_lt?: number | null;
  toBirthWeek_lte?: number | null;
  toBirthWeek_not?: number | null;
  toBirthWeek_not_in?: Array<number | null> | null;
  topicsCollection_exists?: boolean | null;
  uri?: string | null;
  uri_contains?: string | null;
  uri_exists?: boolean | null;
  uri_in?: Array<string | null> | null;
  uri_not?: string | null;
  uri_not_contains?: string | null;
  uri_not_in?: Array<string | null> | null;
  video_exists?: boolean | null;
};

export type cfAuthorNestedFilter = {
  AND?: Array<cfAuthorNestedFilter | null> | null;
  OR?: Array<cfAuthorNestedFilter | null> | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  name?: string | null;
  name_contains?: string | null;
  name_exists?: boolean | null;
  name_in?: Array<string | null> | null;
  name_not?: string | null;
  name_not_contains?: string | null;
  name_not_in?: Array<string | null> | null;
  portrait_exists?: boolean | null;
  sys?: SysFilter | null;
  title?: string | null;
  title_contains?: string | null;
  title_exists?: boolean | null;
  title_in?: Array<string | null> | null;
  title_not?: string | null;
  title_not_contains?: string | null;
  title_not_in?: Array<string | null> | null;
};

export type cfBreedNestedFilter = {
  AND?: Array<cfBreedNestedFilter | null> | null;
  OR?: Array<cfBreedNestedFilter | null> | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  id?: string | null;
  id_contains?: string | null;
  id_exists?: boolean | null;
  id_in?: Array<string | null> | null;
  id_not?: string | null;
  id_not_contains?: string | null;
  id_not_in?: Array<string | null> | null;
  lifeAgeGroup?: number | null;
  lifeAgeGroup_exists?: boolean | null;
  lifeAgeGroup_gt?: number | null;
  lifeAgeGroup_gte?: number | null;
  lifeAgeGroup_in?: Array<number | null> | null;
  lifeAgeGroup_lt?: number | null;
  lifeAgeGroup_lte?: number | null;
  lifeAgeGroup_not?: number | null;
  lifeAgeGroup_not_in?: Array<number | null> | null;
  name?: string | null;
  name_contains?: string | null;
  name_exists?: boolean | null;
  name_in?: Array<string | null> | null;
  name_not?: string | null;
  name_not_contains?: string | null;
  name_not_in?: Array<string | null> | null;
  species_exists?: boolean | null;
  sys?: SysFilter | null;
};

export type cfSpeciesNestedFilter = {
  AND?: Array<cfSpeciesNestedFilter | null> | null;
  OR?: Array<cfSpeciesNestedFilter | null> | null;
  code?: string | null;
  code_contains?: string | null;
  code_exists?: boolean | null;
  code_in?: Array<string | null> | null;
  code_not?: string | null;
  code_not_contains?: string | null;
  code_not_in?: Array<string | null> | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  name?: string | null;
  name_contains?: string | null;
  name_exists?: boolean | null;
  name_in?: Array<string | null> | null;
  name_not?: string | null;
  name_not_contains?: string | null;
  name_not_in?: Array<string | null> | null;
  sys?: SysFilter | null;
};

export type cfTopicNestedFilter = {
  AND?: Array<cfTopicNestedFilter | null> | null;
  OR?: Array<cfTopicNestedFilter | null> | null;
  color?: string | null;
  color_contains?: string | null;
  color_exists?: boolean | null;
  color_in?: Array<string | null> | null;
  color_not?: string | null;
  color_not_contains?: string | null;
  color_not_in?: Array<string | null> | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  icon?: string | null;
  iconBackground?: string | null;
  iconBackground_contains?: string | null;
  iconBackground_exists?: boolean | null;
  iconBackground_in?: Array<string | null> | null;
  iconBackground_not?: string | null;
  iconBackground_not_contains?: string | null;
  iconBackground_not_in?: Array<string | null> | null;
  iconColor?: string | null;
  iconColor_contains?: string | null;
  iconColor_exists?: boolean | null;
  iconColor_in?: Array<string | null> | null;
  iconColor_not?: string | null;
  iconColor_not_contains?: string | null;
  iconColor_not_in?: Array<string | null> | null;
  icon_contains?: string | null;
  icon_exists?: boolean | null;
  icon_in?: Array<string | null> | null;
  icon_not?: string | null;
  icon_not_contains?: string | null;
  icon_not_in?: Array<string | null> | null;
  image_exists?: boolean | null;
  name?: string | null;
  name_contains?: string | null;
  name_exists?: boolean | null;
  name_in?: Array<string | null> | null;
  name_not?: string | null;
  name_not_contains?: string | null;
  name_not_in?: Array<string | null> | null;
  species_exists?: boolean | null;
  sys?: SysFilter | null;
  uri?: string | null;
  uri_contains?: string | null;
  uri_exists?: boolean | null;
  uri_in?: Array<string | null> | null;
  uri_not?: string | null;
  uri_not_contains?: string | null;
  uri_not_in?: Array<string | null> | null;
};

export type cfVideoNestedFilter = {
  AND?: Array<cfVideoNestedFilter | null> | null;
  OR?: Array<cfVideoNestedFilter | null> | null;
  contentfulMetadata?: ContentfulMetadataFilter | null;
  lengthSeconds?: number | null;
  lengthSeconds_exists?: boolean | null;
  lengthSeconds_gt?: number | null;
  lengthSeconds_gte?: number | null;
  lengthSeconds_in?: Array<number | null> | null;
  lengthSeconds_lt?: number | null;
  lengthSeconds_lte?: number | null;
  lengthSeconds_not?: number | null;
  lengthSeconds_not_in?: Array<number | null> | null;
  media_exists?: boolean | null;
  mux_exists?: boolean | null;
  placeholderImage_exists?: boolean | null;
  sys?: SysFilter | null;
  title?: string | null;
  title_contains?: string | null;
  title_exists?: boolean | null;
  title_in?: Array<string | null> | null;
  title_not?: string | null;
  title_not_contains?: string | null;
  title_not_in?: Array<string | null> | null;
};

export type ArticlesForSitemap_sitemapArticles = {
  __typename: 'ArticleUris',
  loc: string,
  lastmod: string,
  changefreq: string,
  priority: number
};

export type ArticlesForSitemap = {
  sitemapArticles: Array<ArticlesForSitemap_sitemapArticles | null> | null
};


export type ArticlesForSitemapVariables = Exact<{
  locale: string;
}>;

export type ArticleCardArticle_sys = {
  __typename: 'Sys',
  id: string,
  firstPublishedAt: any
};

export type ArticleCardArticle_mainImage_sys = {
  __typename: 'Sys',
  id: string
};

export type ArticleCardArticle_mainImage = {
  __typename: 'Asset',
  contentType: string | null,
  url: string | null,
  description: string | null,
  sys: ArticleCardArticle_mainImage_sys
};

export type ArticleCardArticle_video_sys = {
  __typename: 'Sys',
  id: string
};

export type ArticleCardArticle_video = {
  __typename: 'Video',
  sys: ArticleCardArticle_video_sys
};

export type ArticleCardArticle_category_sys = {
  __typename: 'Sys',
  id: string
};

export type ArticleCardArticle_category = {
  __typename: 'Topic',
  name: string | null,
  sys: ArticleCardArticle_category_sys
};

export type ArticleCardArticle_topicsCollection_items_sys = {
  __typename: 'Sys',
  id: string
};

export type ArticleCardArticle_topicsCollection_items = {
  __typename: 'Topic',
  name: string | null,
  sys: ArticleCardArticle_topicsCollection_items_sys
};

export type ArticleCardArticle_topicsCollection = {
  __typename: 'ArticleTopicsCollection',
  items: Array<ArticleCardArticle_topicsCollection_items | null>
};

export type ArticleCardArticle = {
  __typename: 'Article',
  org: Array<string | null> | null,
  uri: string | null,
  title: string | null,
  metadataTitle: string | null,
  readTime: number | null,
  shortText: string | null,
  sys: ArticleCardArticle_sys,
  mainImage: ArticleCardArticle_mainImage | null,
  video: ArticleCardArticle_video | null,
  category: ArticleCardArticle_category | null,
  topicsCollection: ArticleCardArticle_topicsCollection | null
};

export type MediaAsset_sys = {
  __typename: 'Sys',
  id: string
};

export type MediaAsset = {
  __typename: 'Asset',
  contentType: string | null,
  url: string | null,
  description: string | null,
  sys: MediaAsset_sys
};

export type ArticleList_sys = {
  __typename: 'Sys',
  publishedAt: any,
  id: string
};

export type ArticleList = {
  __typename: 'ComponentArticleList',
  sys: ArticleList_sys
};

export type ComponentArticleList_componentArticleList_articlesCollection_items_sys = {
  __typename: 'Sys',
  id: string,
  firstPublishedAt: any
};

export type ComponentArticleList_componentArticleList_articlesCollection_items = {
  __typename: 'Article',
  org: Array<string | null> | null,
  uri: string | null,
  title: string | null,
  metadataTitle: string | null,
  readTime: number | null,
  shortText: string | null,
  sys: ComponentArticleList_componentArticleList_articlesCollection_items_sys,
  mainImage: ArticleCardArticle_mainImage | null,
  video: ArticleCardArticle_video | null,
  category: ArticleCardArticle_category | null,
  topicsCollection: ArticleCardArticle_topicsCollection | null
};

export type ComponentArticleList_componentArticleList_articlesCollection = {
  __typename: 'ComponentArticleListArticlesCollection',
  items: Array<ComponentArticleList_componentArticleList_articlesCollection_items | null>
};

export type ComponentArticleList_componentArticleList_c2A_destination_Page = {
  __typename: 'Page',
  slug: string | null
};

export type ComponentArticleList_componentArticleList_c2A_destination_Url = {
  __typename: 'Url',
  url: string | null
};

export type ComponentArticleList_componentArticleList_c2A_destination =
  | ComponentArticleList_componentArticleList_c2A_destination_Page
  | ComponentArticleList_componentArticleList_c2A_destination_Url
;

export type ComponentArticleList_componentArticleList_c2A_sys = {
  __typename: 'Sys',
  id: string
};

export type ComponentArticleList_componentArticleList_c2A = {
  __typename: 'ComponentC2A',
  type: string | null,
  title: string | null,
  info: string | null,
  color: string | null,
  style: boolean | null,
  destination: ComponentArticleList_componentArticleList_c2A_destination | null,
  sys: ComponentArticleList_componentArticleList_c2A_sys
};

export type ComponentArticleList_componentArticleList_sys = {
  __typename: 'Sys',
  publishedAt: any
};

export type ComponentArticleList_componentArticleList = {
  __typename: 'ComponentArticleList',
  title: string | null,
  description: string | null,
  articlesCollection: ComponentArticleList_componentArticleList_articlesCollection | null,
  c2A: ComponentArticleList_componentArticleList_c2A | null,
  sys: ComponentArticleList_componentArticleList_sys
};

export type ComponentArticleList = {
  componentArticleList: ComponentArticleList_componentArticleList | null
};


export type ComponentArticleListVariables = Exact<{
  id: string;
  locale?: string | null;
  preview?: boolean | null;
}>;

export type Benefits_benefitItemsCollection_items_image_sys = {
  __typename: 'Sys',
  id: string
};

export type Benefits_benefitItemsCollection_items_image = {
  __typename: 'Asset',
  url: string | null,
  description: string | null,
  width: number | null,
  height: number | null,
  contentType: string | null,
  sys: Benefits_benefitItemsCollection_items_image_sys
};

export type Benefits_benefitItemsCollection_items = {
  __typename: 'ListItem',
  title: string | null,
  text: string | null,
  description: string | null,
  icon: string | null,
  color: string | null,
  image: Benefits_benefitItemsCollection_items_image | null
};

export type Benefits_benefitItemsCollection = {
  __typename: 'ComponentBenefitsBenefitItemsCollection',
  items: Array<Benefits_benefitItemsCollection_items | null>
};

export type Benefits_c2A = {
  __typename: 'ComponentC2A',
  type: string | null,
  title: string | null,
  info: string | null,
  color: string | null,
  style: boolean | null,
  destination: ComponentArticleList_componentArticleList_c2A_destination | null,
  sys: ComponentArticleList_componentArticleList_c2A_sys
};

export type Benefits_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type Benefits = {
  __typename: 'ComponentBenefits',
  highlight: string | null,
  title: string | null,
  text: string | null,
  benefitLayout: boolean | null,
  listLayout: boolean | null,
  variation: string | null,
  benefitItemsCollection: Benefits_benefitItemsCollection | null,
  c2A: Benefits_c2A | null,
  sys: Benefits_sys
};

export type C2A = {
  __typename: 'ComponentC2A',
  type: string | null,
  title: string | null,
  info: string | null,
  color: string | null,
  style: boolean | null,
  destination: ComponentArticleList_componentArticleList_c2A_destination | null,
  sys: ComponentArticleList_componentArticleList_c2A_sys
};

export type Cards_cardsCollection_items_ComponentTextAndMedia_listItemsCollection_items = {
  __typename: 'ListItem',
  title: string | null,
  text: string | null,
  icon: string | null
};

export type Cards_cardsCollection_items_ComponentTextAndMedia_listItemsCollection = {
  __typename: 'ComponentTextAndMediaListItemsCollection',
  items: Array<Cards_cardsCollection_items_ComponentTextAndMedia_listItemsCollection_items | null>
};

export type Cards_cardsCollection_items_ComponentTextAndMedia_c2A = {
  __typename: 'ComponentC2A',
  type: string | null,
  title: string | null,
  info: string | null,
  color: string | null,
  style: boolean | null,
  destination: ComponentArticleList_componentArticleList_c2A_destination | null,
  sys: ComponentArticleList_componentArticleList_c2A_sys
};

export type Cards_cardsCollection_items_ComponentTextAndMedia_media = {
  __typename: 'Asset',
  title: string | null,
  url: string | null,
  height: number | null,
  width: number | null,
  contentType: string | null
};

export type Cards_cardsCollection_items_ComponentTextAndMedia_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type Cards_cardsCollection_items_Article = {
  __typename: 'Article',
  org: Array<string | null> | null,
  uri: string | null,
  title: string | null,
  metadataTitle: string | null,
  readTime: number | null,
  shortText: string | null,
  sys: ArticleCardArticle_sys,
  mainImage: ArticleCardArticle_mainImage | null,
  video: ArticleCardArticle_video | null,
  category: ArticleCardArticle_category | null,
  topicsCollection: ArticleCardArticle_topicsCollection | null
};

export type Cards_cardsCollection_items_ComponentTextAndMedia = {
  __typename: 'ComponentTextAndMedia',
  highlight: string | null,
  title: string | null,
  intro: string | null,
  text: string | null,
  theme: string | null,
  layout: boolean | null,
  listLayout: boolean | null,
  listStyle: string | null,
  listItemsCollection: Cards_cardsCollection_items_ComponentTextAndMedia_listItemsCollection | null,
  c2A: Cards_cardsCollection_items_ComponentTextAndMedia_c2A | null,
  media: Cards_cardsCollection_items_ComponentTextAndMedia_media | null,
  sys: Cards_cardsCollection_items_ComponentTextAndMedia_sys
};

export type Cards_cardsCollection_items =
  | Cards_cardsCollection_items_Article
  | Cards_cardsCollection_items_ComponentTextAndMedia
;

export type Cards_cardsCollection = {
  __typename: 'ComponentCardsCardsCollection',
  items: Array<Cards_cardsCollection_items | null>
};

export type Cards_c2A = {
  __typename: 'ComponentC2A',
  type: string | null,
  title: string | null,
  info: string | null,
  color: string | null,
  style: boolean | null,
  destination: ComponentArticleList_componentArticleList_c2A_destination | null,
  sys: ComponentArticleList_componentArticleList_c2A_sys
};

export type Cards_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type Cards = {
  __typename: 'ComponentCards',
  highlight: string | null,
  title: string | null,
  text: string | null,
  cardsCollection: Cards_cardsCollection | null,
  c2A: Cards_c2A | null,
  sys: Cards_sys
};

export type SubmitWithdrawalRequest_submitWithdrawalRequest = {
  __typename: 'SubmitWithdrawalRequestResult',
  success: boolean
};

export type SubmitWithdrawalRequest = {
  submitWithdrawalRequest: SubmitWithdrawalRequest_submitWithdrawalRequest
};


export type SubmitWithdrawalRequestVariables = Exact<{
  input: SubmitWithdrawalRequestInput;
}>;

export type Component_c2A = {
  __typename: 'ComponentC2A',
  type: string | null,
  title: string | null,
  info: string | null,
  color: string | null,
  style: boolean | null,
  destination: ComponentArticleList_componentArticleList_c2A_destination | null,
  sys: ComponentArticleList_componentArticleList_c2A_sys
};

export type Component_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type Component = {
  __typename: 'Component',
  highlight: string | null,
  title: string | null,
  type: string | null,
  theme: string | null,
  props: any,
  c2A: Component_c2A | null,
  sys: Component_sys
};

export type FAQ_itemsCollection_items_sys = {
  __typename: 'Sys',
  id: string
};

export type FAQ_itemsCollection_items_answer = {
  __typename: 'FaqItemAnswer',
  json: any
};

export type FAQ_itemsCollection_items = {
  __typename: 'FaqItem',
  question: string | null,
  sys: FAQ_itemsCollection_items_sys,
  answer: FAQ_itemsCollection_items_answer | null
};

export type FAQ_itemsCollection = {
  __typename: 'ComponentFaqItemsCollection',
  items: Array<FAQ_itemsCollection_items | null>
};

export type FAQ_c2A = {
  __typename: 'ComponentC2A',
  type: string | null,
  title: string | null,
  info: string | null,
  color: string | null,
  style: boolean | null,
  destination: ComponentArticleList_componentArticleList_c2A_destination | null,
  sys: ComponentArticleList_componentArticleList_c2A_sys
};

export type FAQ_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type FAQ = {
  __typename: 'ComponentFaq',
  highlight: string | null,
  title: string | null,
  text: string | null,
  tagId: string | null,
  itemsCollection: FAQ_itemsCollection | null,
  c2A: FAQ_c2A | null,
  sys: FAQ_sys
};

export type Hero_c2A = {
  __typename: 'ComponentC2A',
  type: string | null,
  title: string | null,
  info: string | null,
  color: string | null,
  style: boolean | null,
  destination: ComponentArticleList_componentArticleList_c2A_destination | null,
  sys: ComponentArticleList_componentArticleList_c2A_sys
};

export type Hero_listItemsCollection_items = {
  __typename: 'ListItem',
  title: string | null,
  text: string | null,
  icon: string | null
};

export type Hero_listItemsCollection = {
  __typename: 'ComponentHeroListItemsCollection',
  items: Array<Hero_listItemsCollection_items | null>
};

export type Hero_badgesCollection_items = {
  __typename: 'Asset',
  title: string | null,
  description: string | null,
  url: string | null,
  height: number | null,
  width: number | null,
  contentType: string | null
};

export type Hero_badgesCollection = {
  __typename: 'AssetCollection',
  items: Array<Hero_badgesCollection_items | null>
};

export type Hero_thumbnail = {
  __typename: 'Asset',
  title: string | null,
  url: string | null,
  height: number | null,
  width: number | null,
  contentType: string | null
};

export type Hero_media = {
  __typename: 'Asset',
  title: string | null,
  url: string | null,
  height: number | null,
  width: number | null,
  contentType: string | null
};

export type Hero_desktopPosterImage = {
  __typename: 'Asset',
  title: string | null,
  url: string | null,
  height: number | null,
  width: number | null,
  contentType: string | null
};

export type Hero_mobilePosterImage = {
  __typename: 'Asset',
  title: string | null,
  url: string | null,
  height: number | null,
  width: number | null,
  contentType: string | null
};

export type Hero_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type Hero = {
  __typename: 'ComponentHero',
  type: string | null,
  title: string | null,
  text: string | null,
  disclaimer: string | null,
  theme: string | null,
  hideButtons: boolean | null,
  c2A: Hero_c2A | null,
  listItemsCollection: Hero_listItemsCollection | null,
  badgesCollection: Hero_badgesCollection | null,
  thumbnail: Hero_thumbnail | null,
  media: Hero_media | null,
  desktopPosterImage: Hero_desktopPosterImage | null,
  mobilePosterImage: Hero_mobilePosterImage | null,
  sys: Hero_sys
};

export type Packages_c2A = {
  __typename: 'ComponentC2A',
  type: string | null,
  title: string | null,
  info: string | null,
  color: string | null,
  style: boolean | null,
  destination: ComponentArticleList_componentArticleList_c2A_destination | null,
  sys: ComponentArticleList_componentArticleList_c2A_sys
};

export type Packages_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type Packages = {
  __typename: 'ComponentPackages',
  products: Array<string | null> | null,
  layout: boolean | null,
  highlight: string | null,
  title: string | null,
  text: string | null,
  theme: string | null,
  c2A: Packages_c2A | null,
  sys: Packages_sys
};

export type PromoBanner_image_sys = {
  __typename: 'Sys',
  id: string
};

export type PromoBanner_image = {
  __typename: 'Asset',
  url: string | null,
  description: string | null,
  width: number | null,
  height: number | null,
  contentType: string | null,
  sys: PromoBanner_image_sys
};

export type PromoBanner_signature_sys = {
  __typename: 'Sys',
  id: string
};

export type PromoBanner_signature = {
  __typename: 'Asset',
  url: string | null,
  description: string | null,
  width: number | null,
  height: number | null,
  contentType: string | null,
  sys: PromoBanner_signature_sys
};

export type PromoBanner_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type PromoBanner = {
  __typename: 'ComponentPromoBanner',
  showHeader: boolean | null,
  headerTitle: string | null,
  headerSubline: string | null,
  personName: string | null,
  personRole: string | null,
  quote: string | null,
  image: PromoBanner_image | null,
  signature: PromoBanner_signature | null,
  sys: PromoBanner_sys
};

export type RichText_richText = {
  __typename: 'ComponentRichTextRichText',
  json: any
};

export type RichText_c2A = {
  __typename: 'ComponentC2A',
  type: string | null,
  title: string | null,
  info: string | null,
  color: string | null,
  style: boolean | null,
  destination: ComponentArticleList_componentArticleList_c2A_destination | null,
  sys: ComponentArticleList_componentArticleList_c2A_sys
};

export type RichText_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type RichText = {
  __typename: 'ComponentRichText',
  highlight: string | null,
  title: string | null,
  text: string | null,
  theme: string | null,
  richText: RichText_richText | null,
  c2A: RichText_c2A | null,
  sys: RichText_sys
};

export type StructuredData_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type StructuredData = {
  __typename: 'ComponentStructuredData',
  structuredData: any,
  sys: StructuredData_sys
};

export type TextAndList_listItemsCollection_items = {
  __typename: 'ListItem',
  title: string | null,
  text: string | null,
  icon: string | null
};

export type TextAndList_listItemsCollection = {
  __typename: 'ComponentTextAndListListItemsCollection',
  items: Array<TextAndList_listItemsCollection_items | null>
};

export type TextAndList_c2A = {
  __typename: 'ComponentC2A',
  type: string | null,
  title: string | null,
  info: string | null,
  color: string | null,
  style: boolean | null,
  destination: ComponentArticleList_componentArticleList_c2A_destination | null,
  sys: ComponentArticleList_componentArticleList_c2A_sys
};

export type TextAndList_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type TextAndList = {
  __typename: 'ComponentTextAndList',
  highlight: string | null,
  title: string | null,
  intro: string | null,
  text: string | null,
  theme: string | null,
  layout: boolean | null,
  listLayout: boolean | null,
  listStyle: string | null,
  list: Array<string | null> | null,
  listItemsCollection: TextAndList_listItemsCollection | null,
  c2A: TextAndList_c2A | null,
  sys: TextAndList_sys
};

export type TextAndMedia = {
  __typename: 'ComponentTextAndMedia',
  highlight: string | null,
  title: string | null,
  intro: string | null,
  text: string | null,
  theme: string | null,
  layout: boolean | null,
  listLayout: boolean | null,
  listStyle: string | null,
  listItemsCollection: Cards_cardsCollection_items_ComponentTextAndMedia_listItemsCollection | null,
  c2A: Cards_cardsCollection_items_ComponentTextAndMedia_c2A | null,
  media: Cards_cardsCollection_items_ComponentTextAndMedia_media | null,
  sys: Cards_cardsCollection_items_ComponentTextAndMedia_sys
};

export type TextAndMediaCarousel_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type TextAndMediaCarousel_textAndMediaItemsCollection_items = {
  __typename: 'ComponentTextAndMedia',
  highlight: string | null,
  title: string | null,
  intro: string | null,
  text: string | null,
  theme: string | null,
  layout: boolean | null,
  listLayout: boolean | null,
  listStyle: string | null,
  listItemsCollection: Cards_cardsCollection_items_ComponentTextAndMedia_listItemsCollection | null,
  c2A: Cards_cardsCollection_items_ComponentTextAndMedia_c2A | null,
  media: Cards_cardsCollection_items_ComponentTextAndMedia_media | null,
  sys: Cards_cardsCollection_items_ComponentTextAndMedia_sys
};

export type TextAndMediaCarousel_textAndMediaItemsCollection = {
  __typename: 'ComponentTextAndMediaCarouselTextAndMediaItemsCollection',
  items: Array<TextAndMediaCarousel_textAndMediaItemsCollection_items | null>
};

export type TextAndMediaCarousel = {
  __typename: 'ComponentTextAndMediaCarousel',
  sys: TextAndMediaCarousel_sys,
  textAndMediaItemsCollection: TextAndMediaCarousel_textAndMediaItemsCollection | null
};

export type TextAndText_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type TextAndText = {
  __typename: 'ComponentTextAndText',
  leftHighlight: string | null,
  leftTitle: string | null,
  leftText: string | null,
  rightHighlight: string | null,
  rightTitle: string | null,
  rightText: string | null,
  sys: TextAndText_sys
};

export type VariantContainer_variantsCollection_items_Article = {
  __typename: 'Article'
};

export type VariantContainer_variantsCollection_items_Author = {
  __typename: 'Author'
};

export type VariantContainer_variantsCollection_items_BreedsArticle = {
  __typename: 'BreedsArticle'
};

export type VariantContainer_variantsCollection_items_Checklist = {
  __typename: 'Checklist'
};

export type VariantContainer_variantsCollection_items_ChecklistItem = {
  __typename: 'ChecklistItem'
};

export type VariantContainer_variantsCollection_items_Component = {
  __typename: 'Component',
  highlight: string | null,
  title: string | null,
  type: string | null,
  theme: string | null,
  props: any,
  c2A: Component_c2A | null,
  sys: Component_sys
};

export type VariantContainer_variantsCollection_items_ComponentArticleList = {
  __typename: 'ComponentArticleList'
};

export type VariantContainer_variantsCollection_items_ComponentBanner = {
  __typename: 'ComponentBanner'
};

export type VariantContainer_variantsCollection_items_ComponentBenefits = {
  __typename: 'ComponentBenefits',
  highlight: string | null,
  title: string | null,
  text: string | null,
  benefitLayout: boolean | null,
  listLayout: boolean | null,
  variation: string | null,
  benefitItemsCollection: Benefits_benefitItemsCollection | null,
  c2A: Benefits_c2A | null,
  sys: Benefits_sys
};

export type VariantContainer_variantsCollection_items_ComponentButton = {
  __typename: 'ComponentButton'
};

export type VariantContainer_variantsCollection_items_ComponentC2A = {
  __typename: 'ComponentC2A'
};

export type VariantContainer_variantsCollection_items_ComponentCards = {
  __typename: 'ComponentCards',
  highlight: string | null,
  title: string | null,
  text: string | null,
  cardsCollection: Cards_cardsCollection | null,
  c2A: Cards_c2A | null,
  sys: Cards_sys
};

export type VariantContainer_variantsCollection_items_ComponentColumn = {
  __typename: 'ComponentColumn'
};

export type VariantContainer_variantsCollection_items_ComponentColumns = {
  __typename: 'ComponentColumns'
};

export type VariantContainer_variantsCollection_items_ComponentFactBlock = {
  __typename: 'ComponentFactBlock'
};

export type VariantContainer_variantsCollection_items_ComponentFaq = {
  __typename: 'ComponentFaq',
  highlight: string | null,
  title: string | null,
  text: string | null,
  tagId: string | null,
  itemsCollection: FAQ_itemsCollection | null,
  c2A: FAQ_c2A | null,
  sys: FAQ_sys
};

export type VariantContainer_variantsCollection_items_ComponentFirstVetCard = {
  __typename: 'ComponentFirstVetCard'
};

export type VariantContainer_variantsCollection_items_ComponentGutter = {
  __typename: 'ComponentGutter'
};

export type VariantContainer_variantsCollection_items_ComponentHero = {
  __typename: 'ComponentHero',
  type: string | null,
  title: string | null,
  text: string | null,
  disclaimer: string | null,
  theme: string | null,
  hideButtons: boolean | null,
  c2A: Hero_c2A | null,
  listItemsCollection: Hero_listItemsCollection | null,
  badgesCollection: Hero_badgesCollection | null,
  thumbnail: Hero_thumbnail | null,
  media: Hero_media | null,
  desktopPosterImage: Hero_desktopPosterImage | null,
  mobilePosterImage: Hero_mobilePosterImage | null,
  sys: Hero_sys
};

export type VariantContainer_variantsCollection_items_ComponentList = {
  __typename: 'ComponentList'
};

export type VariantContainer_variantsCollection_items_ComponentPackages = {
  __typename: 'ComponentPackages',
  products: Array<string | null> | null,
  layout: boolean | null,
  highlight: string | null,
  title: string | null,
  text: string | null,
  theme: string | null,
  c2A: Packages_c2A | null,
  sys: Packages_sys
};

export type VariantContainer_variantsCollection_items_ComponentPromoBanner = {
  __typename: 'ComponentPromoBanner',
  showHeader: boolean | null,
  headerTitle: string | null,
  headerSubline: string | null,
  personName: string | null,
  personRole: string | null,
  quote: string | null,
  image: PromoBanner_image | null,
  signature: PromoBanner_signature | null,
  sys: PromoBanner_sys
};

export type VariantContainer_variantsCollection_items_ComponentRichText = {
  __typename: 'ComponentRichText',
  highlight: string | null,
  title: string | null,
  text: string | null,
  theme: string | null,
  richText: RichText_richText | null,
  c2A: RichText_c2A | null,
  sys: RichText_sys
};

export type VariantContainer_variantsCollection_items_ComponentStructuredData = {
  __typename: 'ComponentStructuredData',
  structuredData: any,
  sys: StructuredData_sys
};

export type VariantContainer_variantsCollection_items_ComponentTextAndList = {
  __typename: 'ComponentTextAndList',
  highlight: string | null,
  title: string | null,
  intro: string | null,
  text: string | null,
  theme: string | null,
  layout: boolean | null,
  listLayout: boolean | null,
  listStyle: string | null,
  list: Array<string | null> | null,
  listItemsCollection: TextAndList_listItemsCollection | null,
  c2A: TextAndList_c2A | null,
  sys: TextAndList_sys
};

export type VariantContainer_variantsCollection_items_ComponentTextAndMedia = {
  __typename: 'ComponentTextAndMedia',
  highlight: string | null,
  title: string | null,
  intro: string | null,
  text: string | null,
  theme: string | null,
  layout: boolean | null,
  listLayout: boolean | null,
  listStyle: string | null,
  listItemsCollection: Cards_cardsCollection_items_ComponentTextAndMedia_listItemsCollection | null,
  c2A: Cards_cardsCollection_items_ComponentTextAndMedia_c2A | null,
  media: Cards_cardsCollection_items_ComponentTextAndMedia_media | null,
  sys: Cards_cardsCollection_items_ComponentTextAndMedia_sys
};

export type VariantContainer_variantsCollection_items_ComponentTextAndMediaCarousel = {
  __typename: 'ComponentTextAndMediaCarousel',
  sys: TextAndMediaCarousel_sys,
  textAndMediaItemsCollection: TextAndMediaCarousel_textAndMediaItemsCollection | null
};

export type VariantContainer_variantsCollection_items_ComponentTextAndText = {
  __typename: 'ComponentTextAndText',
  leftHighlight: string | null,
  leftTitle: string | null,
  leftText: string | null,
  rightHighlight: string | null,
  rightTitle: string | null,
  rightText: string | null,
  sys: TextAndText_sys
};

export type VariantContainer_variantsCollection_items_ContentfulBreed = {
  __typename: 'ContentfulBreed'
};

export type VariantContainer_variantsCollection_items_ContentfulTask = {
  __typename: 'ContentfulTask'
};

export type VariantContainer_variantsCollection_items_Course = {
  __typename: 'Course'
};

export type VariantContainer_variantsCollection_items_CourseSection = {
  __typename: 'CourseSection'
};

export type VariantContainer_variantsCollection_items_DailyContent = {
  __typename: 'DailyContent'
};

export type VariantContainer_variantsCollection_items_FaqItem = {
  __typename: 'FaqItem'
};

export type VariantContainer_variantsCollection_items_Image = {
  __typename: 'Image'
};

export type VariantContainer_variantsCollection_items_KnowledgeScreen = {
  __typename: 'KnowledgeScreen'
};

export type VariantContainer_variantsCollection_items_ListItem = {
  __typename: 'ListItem'
};

export type VariantContainer_variantsCollection_items_NavigationItem = {
  __typename: 'NavigationItem'
};

export type VariantContainer_variantsCollection_items_Page = {
  __typename: 'Page'
};

export type VariantContainer_variantsCollection_items_PageContent = {
  __typename: 'PageContent'
};

export type VariantContainer_variantsCollection_items_Quiz = {
  __typename: 'Quiz'
};

export type VariantContainer_variantsCollection_items_QuizQuestion = {
  __typename: 'QuizQuestion'
};

export type VariantContainer_variantsCollection_items_Redirect = {
  __typename: 'Redirect'
};

export type VariantContainer_variantsCollection_items_ReferralDiscount = {
  __typename: 'ReferralDiscount'
};

export type VariantContainer_variantsCollection_items_Site = {
  __typename: 'Site'
};

export type VariantContainer_variantsCollection_items_Species = {
  __typename: 'Species'
};

export type VariantContainer_variantsCollection_items_Topic = {
  __typename: 'Topic'
};

export type VariantContainer_variantsCollection_items_Track = {
  __typename: 'Track'
};

export type VariantContainer_variantsCollection_items_Url = {
  __typename: 'Url'
};

export type VariantContainer_variantsCollection_items_VariantContainer = {
  __typename: 'VariantContainer'
};

export type VariantContainer_variantsCollection_items_Video = {
  __typename: 'Video'
};

export type VariantContainer_variantsCollection_items_WeeklyArticlesList = {
  __typename: 'WeeklyArticlesList'
};

export type VariantContainer_variantsCollection_items =
  | VariantContainer_variantsCollection_items_Article
  | VariantContainer_variantsCollection_items_Author
  | VariantContainer_variantsCollection_items_BreedsArticle
  | VariantContainer_variantsCollection_items_Checklist
  | VariantContainer_variantsCollection_items_ChecklistItem
  | VariantContainer_variantsCollection_items_Component
  | VariantContainer_variantsCollection_items_ComponentArticleList
  | VariantContainer_variantsCollection_items_ComponentBanner
  | VariantContainer_variantsCollection_items_ComponentBenefits
  | VariantContainer_variantsCollection_items_ComponentButton
  | VariantContainer_variantsCollection_items_ComponentC2A
  | VariantContainer_variantsCollection_items_ComponentCards
  | VariantContainer_variantsCollection_items_ComponentColumn
  | VariantContainer_variantsCollection_items_ComponentColumns
  | VariantContainer_variantsCollection_items_ComponentFactBlock
  | VariantContainer_variantsCollection_items_ComponentFaq
  | VariantContainer_variantsCollection_items_ComponentFirstVetCard
  | VariantContainer_variantsCollection_items_ComponentGutter
  | VariantContainer_variantsCollection_items_ComponentHero
  | VariantContainer_variantsCollection_items_ComponentList
  | VariantContainer_variantsCollection_items_ComponentPackages
  | VariantContainer_variantsCollection_items_ComponentPromoBanner
  | VariantContainer_variantsCollection_items_ComponentRichText
  | VariantContainer_variantsCollection_items_ComponentStructuredData
  | VariantContainer_variantsCollection_items_ComponentTextAndList
  | VariantContainer_variantsCollection_items_ComponentTextAndMedia
  | VariantContainer_variantsCollection_items_ComponentTextAndMediaCarousel
  | VariantContainer_variantsCollection_items_ComponentTextAndText
  | VariantContainer_variantsCollection_items_ContentfulBreed
  | VariantContainer_variantsCollection_items_ContentfulTask
  | VariantContainer_variantsCollection_items_Course
  | VariantContainer_variantsCollection_items_CourseSection
  | VariantContainer_variantsCollection_items_DailyContent
  | VariantContainer_variantsCollection_items_FaqItem
  | VariantContainer_variantsCollection_items_Image
  | VariantContainer_variantsCollection_items_KnowledgeScreen
  | VariantContainer_variantsCollection_items_ListItem
  | VariantContainer_variantsCollection_items_NavigationItem
  | VariantContainer_variantsCollection_items_Page
  | VariantContainer_variantsCollection_items_PageContent
  | VariantContainer_variantsCollection_items_Quiz
  | VariantContainer_variantsCollection_items_QuizQuestion
  | VariantContainer_variantsCollection_items_Redirect
  | VariantContainer_variantsCollection_items_ReferralDiscount
  | VariantContainer_variantsCollection_items_Site
  | VariantContainer_variantsCollection_items_Species
  | VariantContainer_variantsCollection_items_Topic
  | VariantContainer_variantsCollection_items_Track
  | VariantContainer_variantsCollection_items_Url
  | VariantContainer_variantsCollection_items_VariantContainer
  | VariantContainer_variantsCollection_items_Video
  | VariantContainer_variantsCollection_items_WeeklyArticlesList
;

export type VariantContainer_variantsCollection = {
  __typename: 'VariantContainerVariantsCollection',
  items: Array<VariantContainer_variantsCollection_items | null>
};

export type VariantContainer_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type VariantContainer = {
  __typename: 'VariantContainer',
  experimentId: string | null,
  meta: any,
  variantsCollection: VariantContainer_variantsCollection | null,
  sys: VariantContainer_sys
};

export type GenerateIdToken_generateIdToken = {
  __typename: 'RedirectUrl',
  redirectUrl: string
};

export type GenerateIdToken = {
  generateIdToken: GenerateIdToken_generateIdToken | null
};


export type GenerateIdTokenVariables = Exact<{ [key: string]: never; }>;

export type PaymentPolicies_paymentPolicies_policies_client_addresses = {
  __typename: 'KennelAddress',
  city: string | null,
  zip: string | null,
  line1: string | null
};

export type PaymentPolicies_paymentPolicies_policies_client_metadata = {
  __typename: 'KennelClientMetadata',
  municipality: string | null,
  payoutMethodId: string | null,
  payoutMethodProvider: string | null
};

export type PaymentPolicies_paymentPolicies_policies_client = {
  __typename: 'KennelClient',
  _id: string,
  name: string,
  email: string,
  phone: string | null,
  addresses: Array<PaymentPolicies_paymentPolicies_policies_client_addresses> | null,
  metadata: PaymentPolicies_paymentPolicies_policies_client_metadata | null
};

export type PaymentPolicies_paymentPolicies_policies_discounts = {
  __typename: 'KennelDiscount',
  _id: string,
  name: string,
  type: DiscountType,
  total: number | null
};

export type PaymentPolicies_paymentPolicies_policies_fees = {
  __typename: 'KennelFee',
  _id: string,
  total: number,
  name: string
};

export type PaymentPolicies_paymentPolicies_policies_metadata = {
  __typename: 'KennelPolicyMetadata',
  discount: string | null,
  cancelPreviousInsurance: string | null,
  previousInsurance: string | null
};

export type PaymentPolicies_paymentPolicies_policies_paymentMethod = {
  __typename: 'KennelPolicyPaymentMethod',
  id: string,
  type: string | null,
  provider: PaymentMethodEnum
};

export type PaymentPolicies_paymentPolicies_policies_payoutMethod = {
  __typename: 'KennelPolicyPayoutMethod',
  id: string,
  provider: PayoutMethodEnum
};

export type PaymentPolicies_paymentPolicies_policies_ratingsData = {
  __typename: 'KennelPolicyRatingsData',
  name: string | null,
  breed: string | null,
  lifeLimit: number | null,
  birthday: string | null,
  copay: number | null,
  sex: string | null,
  access: string | null,
  breedersAddOn: boolean | null,
  lifeUtilityAddOn: string | null
};

export type PaymentPolicies_paymentPolicies_policies_product = {
  __typename: 'KennelProduct',
  name: ProductEnum
};

export type PaymentPolicies_paymentPolicies_policies_copays = {
  __typename: 'KennelCopay',
  total: number | null
};

export type PaymentPolicies_paymentPolicies_policies_paymentCandidates_currency = {
  __typename: 'Currency',
  _id: string | null,
  code: string | null
};

export type PaymentPolicies_paymentPolicies_policies_paymentCandidates_policy_product = {
  __typename: 'KennelProduct',
  name: ProductEnum
};

export type PaymentPolicies_paymentPolicies_policies_paymentCandidates_policy_ratingsData = {
  __typename: 'KennelPolicyRatingsData',
  name: string | null
};

export type PaymentPolicies_paymentPolicies_policies_paymentCandidates_policy = {
  __typename: 'KennelPolicy',
  billingInterval: number,
  policyNumber: string,
  product: PaymentPolicies_paymentPolicies_policies_paymentCandidates_policy_product | null,
  ratingsData: PaymentPolicies_paymentPolicies_policies_paymentCandidates_policy_ratingsData | null
};

export type PaymentPolicies_paymentPolicies_policies_paymentCandidates_invoices_lines = {
  __typename: 'KennelInvoiceLine',
  name: string | null,
  total: number | null,
  type: string | null
};

export type PaymentPolicies_paymentPolicies_policies_paymentCandidates_invoices = {
  __typename: 'KennelInvoice',
  _id: string,
  status: string | null,
  paidOn: string | null,
  issuedDate: string | null,
  billingStartDate: string | null,
  billingEndDate: string | null,
  lines: Array<PaymentPolicies_paymentPolicies_policies_paymentCandidates_invoices_lines> | null
};

export type PaymentPolicies_paymentPolicies_policies_paymentCandidates_transactions = {
  __typename: 'PaymentTransaction',
  id: string | null,
  status: PaymentTransactionStatus | null,
  error: string | null,
  createdAt: string | null,
  updatedAt: string | null,
  stripePaymentMethodId: string | null,
  trustlyAccountId: string | null
};

export type PaymentPolicies_paymentPolicies_policies_paymentCandidates_paymentPeriod = {
  __typename: 'PaymentPeriod',
  start: string | null,
  end: string | null
};

export type PaymentPolicies_paymentPolicies_policies_paymentCandidates = {
  __typename: 'PaymentCandidate',
  id: string,
  amount: number | null,
  date: string | null,
  isFirstPayment: boolean | null,
  dunningEndDate: string | null,
  currency: PaymentPolicies_paymentPolicies_policies_paymentCandidates_currency | null,
  policy: PaymentPolicies_paymentPolicies_policies_paymentCandidates_policy | null,
  invoices: Array<PaymentPolicies_paymentPolicies_policies_paymentCandidates_invoices> | null,
  transactions: Array<PaymentPolicies_paymentPolicies_policies_paymentCandidates_transactions> | null,
  paymentPeriod: PaymentPolicies_paymentPolicies_policies_paymentCandidates_paymentPeriod | null
};

export type PaymentPolicies_paymentPolicies_policies_currency = {
  __typename: 'Currency',
  name: string | null,
  code: string | null,
  symbol: string | null
};

export type PaymentPolicies_paymentPolicies_policies = {
  __typename: 'KennelPolicy',
  _id: string,
  policyNumber: string,
  limit: number,
  deductible: number,
  premium: number | null,
  netPremium: number,
  termPremium: number,
  billingInterval: number,
  total: number | null,
  effectiveDate: string,
  status: string,
  planName: string,
  client: PaymentPolicies_paymentPolicies_policies_client | null,
  discounts: Array<PaymentPolicies_paymentPolicies_policies_discounts>,
  fees: Array<PaymentPolicies_paymentPolicies_policies_fees>,
  metadata: PaymentPolicies_paymentPolicies_policies_metadata | null,
  paymentMethod: PaymentPolicies_paymentPolicies_policies_paymentMethod | null,
  payoutMethod: PaymentPolicies_paymentPolicies_policies_payoutMethod | null,
  ratingsData: PaymentPolicies_paymentPolicies_policies_ratingsData | null,
  product: PaymentPolicies_paymentPolicies_policies_product | null,
  copays: Array<PaymentPolicies_paymentPolicies_policies_copays> | null,
  paymentCandidates: Array<PaymentPolicies_paymentPolicies_policies_paymentCandidates> | null,
  currency: PaymentPolicies_paymentPolicies_policies_currency | null
};

export type PaymentPolicies_paymentPolicies_paymentMethods_bacs_debit = {
  __typename: 'PaymentMethodStripeBacsDetails',
  last4: string | null,
  fingerprint: string | null
};

export type PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeCard_card = {
  __typename: 'PaymentMethodStripeCardDetails',
  brand: string | null,
  last4: string | null,
  fingerprint: string | null,
  exp_month: number | null,
  exp_year: number | null
};

export type PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeLink_link = {
  __typename: 'PaymentMethodStripeLinkDetails',
  email: string | null
};

export type PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripePaypal_paypal = {
  __typename: 'PaymentMethodStripePaypalDetails',
  payer_id: string | null,
  payer_email: string | null
};

export type PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeSepa_sepa_debit = {
  __typename: 'PaymentMethodStripeSepaDetails',
  last4: string | null,
  fingerprint: string | null
};

export type PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeBacs = {
  __typename: 'PaymentMethodStripeBacs',
  id: string | null,
  bacs_debit: PaymentPolicies_paymentPolicies_paymentMethods_bacs_debit | null
};

export type PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeCard = {
  __typename: 'PaymentMethodStripeCard',
  id: string | null,
  card: PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeCard_card | null
};

export type PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeLink = {
  __typename: 'PaymentMethodStripeLink',
  id: string | null,
  link: PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeLink_link | null
};

export type PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripePaypal = {
  __typename: 'PaymentMethodStripePaypal',
  id: string | null,
  paypal: PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripePaypal_paypal | null
};

export type PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeSepa = {
  __typename: 'PaymentMethodStripeSepa',
  id: string | null,
  sepa_debit: PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeSepa_sepa_debit | null
};

export type PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodTrustly = {
  __typename: 'PaymentMethodTrustly',
  id: string | null,
  clearinghouse: string | null,
  bank: string | null,
  descriptor: string | null,
  lastdigits: string | null,
  verified: string | null,
  directdebitmandate: string | null,
  type: string | null
};

export type PaymentPolicies_paymentPolicies_paymentMethods =
  | PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeBacs
  | PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeCard
  | PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeLink
  | PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripePaypal
  | PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeSepa
  | PaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodTrustly
;

export type PaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodAtlar_identifiers = {
  __typename: 'PaymentMethodAtlarIdentifier',
  number: string | null,
  type: string | null,
  market: string | null
};

export type PaymentPolicies_paymentPolicies_payoutMethods_PaymentMethodTrustly = {
  __typename: 'PaymentMethodTrustly',
  id: string | null,
  clearinghouse: string | null,
  bank: string | null,
  descriptor: string | null,
  lastdigits: string | null,
  verified: string | null,
  directdebitmandate: string | null,
  type: string | null
};

export type PaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodAtlar = {
  __typename: 'PayoutMethodAtlar',
  id: string | null,
  identifiers: Array<PaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodAtlar_identifiers> | null
};

export type PaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodPaypal = {
  __typename: 'PayoutMethodPaypal',
  id: string | null,
  email: string | null
};

export type PaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodSwish = {
  __typename: 'PayoutMethodSwish',
  id: string | null,
  phone: string | null
};

export type PaymentPolicies_paymentPolicies_payoutMethods =
  | PaymentPolicies_paymentPolicies_payoutMethods_PaymentMethodTrustly
  | PaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodAtlar
  | PaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodPaypal
  | PaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodSwish
;

export type PaymentPolicies_paymentPolicies = {
  __typename: 'PaymentPoliciesResult',
  policies: Array<PaymentPolicies_paymentPolicies_policies> | null,
  paymentMethods: Array<PaymentPolicies_paymentPolicies_paymentMethods> | null,
  payoutMethods: Array<PaymentPolicies_paymentPolicies_payoutMethods> | null
};

export type PaymentPolicies = {
  paymentPolicies: PaymentPolicies_paymentPolicies | null
};


export type PaymentPoliciesVariables = Exact<{ [key: string]: never; }>;

export type UserPaymentPolicies_paymentPolicies_policies_client_addresses = {
  __typename: 'KennelAddress',
  city: string | null,
  zip: string | null,
  line1: string | null
};

export type UserPaymentPolicies_paymentPolicies_policies_client_metadata = {
  __typename: 'KennelClientMetadata',
  municipality: string | null,
  payoutMethodId: string | null,
  payoutMethodProvider: string | null
};

export type UserPaymentPolicies_paymentPolicies_policies_client = {
  __typename: 'KennelClient',
  _id: string,
  name: string,
  email: string,
  phone: string | null,
  addresses: Array<UserPaymentPolicies_paymentPolicies_policies_client_addresses> | null,
  metadata: UserPaymentPolicies_paymentPolicies_policies_client_metadata | null
};

export type UserPaymentPolicies_paymentPolicies_policies_metadata = {
  __typename: 'KennelPolicyMetadata',
  discount: string | null,
  cancelPreviousInsurance: string | null,
  previousInsurance: string | null
};

export type UserPaymentPolicies_paymentPolicies_policies_paymentMethod = {
  __typename: 'KennelPolicyPaymentMethod',
  id: string,
  type: string | null,
  provider: PaymentMethodEnum
};

export type UserPaymentPolicies_paymentPolicies_policies_payoutMethod = {
  __typename: 'KennelPolicyPayoutMethod',
  id: string,
  provider: PayoutMethodEnum
};

export type UserPaymentPolicies_paymentPolicies_policies_ratingsData = {
  __typename: 'KennelPolicyRatingsData',
  name: string | null,
  breed: string | null,
  lifeLimit: number | null,
  birthday: string | null,
  copay: number | null,
  sex: string | null,
  access: string | null,
  breedersAddOn: boolean | null,
  lifeUtilityAddOn: string | null
};

export type UserPaymentPolicies_paymentPolicies_policies_product = {
  __typename: 'KennelProduct',
  name: ProductEnum
};

export type UserPaymentPolicies_paymentPolicies_policies_copays = {
  __typename: 'KennelCopay',
  total: number | null
};

export type UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_currency = {
  __typename: 'Currency',
  _id: string | null,
  code: string | null
};

export type UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_policy_product = {
  __typename: 'KennelProduct',
  name: ProductEnum
};

export type UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_policy_ratingsData = {
  __typename: 'KennelPolicyRatingsData',
  name: string | null
};

export type UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_policy = {
  __typename: 'KennelPolicy',
  billingInterval: number,
  policyNumber: string,
  product: UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_policy_product | null,
  ratingsData: UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_policy_ratingsData | null
};

export type UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_invoices_lines = {
  __typename: 'KennelInvoiceLine',
  name: string | null,
  total: number | null,
  type: string | null
};

export type UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_invoices = {
  __typename: 'KennelInvoice',
  _id: string,
  status: string | null,
  paidOn: string | null,
  issuedDate: string | null,
  billingStartDate: string | null,
  billingEndDate: string | null,
  lines: Array<UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_invoices_lines> | null
};

export type UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_transactions = {
  __typename: 'PaymentTransaction',
  id: string | null,
  status: PaymentTransactionStatus | null,
  error: string | null,
  createdAt: string | null,
  updatedAt: string | null,
  stripePaymentMethodId: string | null,
  trustlyAccountId: string | null
};

export type UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_paymentPeriod = {
  __typename: 'PaymentPeriod',
  start: string | null,
  end: string | null
};

export type UserPaymentPolicies_paymentPolicies_policies_paymentCandidates = {
  __typename: 'PaymentCandidate',
  id: string,
  amount: number | null,
  date: string | null,
  isFirstPayment: boolean | null,
  dunningEndDate: string | null,
  currency: UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_currency | null,
  policy: UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_policy | null,
  invoices: Array<UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_invoices> | null,
  transactions: Array<UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_transactions> | null,
  paymentPeriod: UserPaymentPolicies_paymentPolicies_policies_paymentCandidates_paymentPeriod | null
};

export type UserPaymentPolicies_paymentPolicies_policies_discounts = {
  __typename: 'KennelDiscount',
  _id: string,
  name: string,
  type: DiscountType,
  total: number | null
};

export type UserPaymentPolicies_paymentPolicies_policies_fees = {
  __typename: 'KennelFee',
  _id: string,
  total: number,
  name: string
};

export type UserPaymentPolicies_paymentPolicies_policies_currency = {
  __typename: 'Currency',
  name: string | null,
  code: string | null,
  symbol: string | null
};

export type UserPaymentPolicies_paymentPolicies_policies = {
  __typename: 'KennelPolicy',
  _id: string,
  policyNumber: string,
  limit: number,
  deductible: number,
  premium: number | null,
  netPremium: number,
  termPremium: number,
  billingInterval: number,
  total: number | null,
  effectiveDate: string,
  status: string,
  planName: string,
  client: UserPaymentPolicies_paymentPolicies_policies_client | null,
  metadata: UserPaymentPolicies_paymentPolicies_policies_metadata | null,
  paymentMethod: UserPaymentPolicies_paymentPolicies_policies_paymentMethod | null,
  payoutMethod: UserPaymentPolicies_paymentPolicies_policies_payoutMethod | null,
  ratingsData: UserPaymentPolicies_paymentPolicies_policies_ratingsData | null,
  product: UserPaymentPolicies_paymentPolicies_policies_product | null,
  copays: Array<UserPaymentPolicies_paymentPolicies_policies_copays> | null,
  paymentCandidates: Array<UserPaymentPolicies_paymentPolicies_policies_paymentCandidates> | null,
  discounts: Array<UserPaymentPolicies_paymentPolicies_policies_discounts>,
  fees: Array<UserPaymentPolicies_paymentPolicies_policies_fees>,
  currency: UserPaymentPolicies_paymentPolicies_policies_currency | null
};

export type UserPaymentPolicies_paymentPolicies_paymentMethods_bacs_debit = {
  __typename: 'PaymentMethodStripeBacsDetails',
  last4: string | null,
  fingerprint: string | null
};

export type UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeCard_card = {
  __typename: 'PaymentMethodStripeCardDetails',
  brand: string | null,
  last4: string | null,
  fingerprint: string | null,
  exp_month: number | null,
  exp_year: number | null
};

export type UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeLink_link = {
  __typename: 'PaymentMethodStripeLinkDetails',
  email: string | null
};

export type UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripePaypal_paypal = {
  __typename: 'PaymentMethodStripePaypalDetails',
  payer_id: string | null,
  payer_email: string | null
};

export type UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeSepa_sepa_debit = {
  __typename: 'PaymentMethodStripeSepaDetails',
  last4: string | null,
  fingerprint: string | null
};

export type UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeBacs = {
  __typename: 'PaymentMethodStripeBacs',
  id: string | null,
  bacs_debit: UserPaymentPolicies_paymentPolicies_paymentMethods_bacs_debit | null
};

export type UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeCard = {
  __typename: 'PaymentMethodStripeCard',
  id: string | null,
  card: UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeCard_card | null
};

export type UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeLink = {
  __typename: 'PaymentMethodStripeLink',
  id: string | null,
  link: UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeLink_link | null
};

export type UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripePaypal = {
  __typename: 'PaymentMethodStripePaypal',
  id: string | null,
  paypal: UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripePaypal_paypal | null
};

export type UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeSepa = {
  __typename: 'PaymentMethodStripeSepa',
  id: string | null,
  sepa_debit: UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeSepa_sepa_debit | null
};

export type UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodTrustly = {
  __typename: 'PaymentMethodTrustly',
  id: string | null,
  clearinghouse: string | null,
  bank: string | null,
  descriptor: string | null,
  lastdigits: string | null,
  verified: string | null,
  directdebitmandate: string | null,
  type: string | null
};

export type UserPaymentPolicies_paymentPolicies_paymentMethods =
  | UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeBacs
  | UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeCard
  | UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeLink
  | UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripePaypal
  | UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodStripeSepa
  | UserPaymentPolicies_paymentPolicies_paymentMethods_PaymentMethodTrustly
;

export type UserPaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodAtlar_identifiers = {
  __typename: 'PaymentMethodAtlarIdentifier',
  number: string | null,
  type: string | null,
  market: string | null
};

export type UserPaymentPolicies_paymentPolicies_payoutMethods_PaymentMethodTrustly = {
  __typename: 'PaymentMethodTrustly',
  id: string | null,
  clearinghouse: string | null,
  bank: string | null,
  descriptor: string | null,
  lastdigits: string | null,
  verified: string | null,
  directdebitmandate: string | null,
  type: string | null
};

export type UserPaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodAtlar = {
  __typename: 'PayoutMethodAtlar',
  id: string | null,
  identifiers: Array<UserPaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodAtlar_identifiers> | null
};

export type UserPaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodPaypal = {
  __typename: 'PayoutMethodPaypal',
  id: string | null,
  email: string | null
};

export type UserPaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodSwish = {
  __typename: 'PayoutMethodSwish',
  id: string | null,
  phone: string | null
};

export type UserPaymentPolicies_paymentPolicies_payoutMethods =
  | UserPaymentPolicies_paymentPolicies_payoutMethods_PaymentMethodTrustly
  | UserPaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodAtlar
  | UserPaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodPaypal
  | UserPaymentPolicies_paymentPolicies_payoutMethods_PayoutMethodSwish
;

export type UserPaymentPolicies_paymentPolicies = {
  __typename: 'PaymentPoliciesResult',
  policies: Array<UserPaymentPolicies_paymentPolicies_policies> | null,
  paymentMethods: Array<UserPaymentPolicies_paymentPolicies_paymentMethods> | null,
  payoutMethods: Array<UserPaymentPolicies_paymentPolicies_payoutMethods> | null
};

export type UserPaymentPolicies = {
  paymentPolicies: UserPaymentPolicies_paymentPolicies | null
};


export type UserPaymentPoliciesVariables = Exact<{ [key: string]: never; }>;

export type Charge_charge_paymentCandidate_currency = {
  __typename: 'Currency',
  _id: string | null,
  code: string | null
};

export type Charge_charge_paymentCandidate_policy_ratingsData = {
  __typename: 'KennelPolicyRatingsData',
  name: string | null
};

export type Charge_charge_paymentCandidate_policy = {
  __typename: 'KennelPolicy',
  ratingsData: Charge_charge_paymentCandidate_policy_ratingsData | null
};

export type Charge_charge_paymentCandidate_invoices = {
  __typename: 'KennelInvoice',
  _id: string,
  status: string | null,
  paidOn: string | null,
  issuedDate: string | null
};

export type Charge_charge_paymentCandidate_transactions = {
  __typename: 'PaymentTransaction',
  id: string | null,
  status: PaymentTransactionStatus | null,
  error: string | null,
  createdAt: string | null,
  updatedAt: string | null
};

export type Charge_charge_paymentCandidate_paymentPeriod = {
  __typename: 'PaymentPeriod',
  start: string | null,
  end: string | null
};

export type Charge_charge_paymentCandidate = {
  __typename: 'PaymentCandidate',
  id: string,
  amount: number | null,
  date: string | null,
  isFirstPayment: boolean | null,
  dunningEndDate: string | null,
  currency: Charge_charge_paymentCandidate_currency | null,
  policy: Charge_charge_paymentCandidate_policy | null,
  invoices: Array<Charge_charge_paymentCandidate_invoices> | null,
  transactions: Array<Charge_charge_paymentCandidate_transactions> | null,
  paymentPeriod: Charge_charge_paymentCandidate_paymentPeriod | null
};

export type Charge_charge_error = {
  __typename: 'ChargeResultError',
  code: string | null,
  message: string | null
};

export type Charge_charge = {
  __typename: 'ChargeResult',
  paymentCandidate: Charge_charge_paymentCandidate | null,
  error: Charge_charge_error | null
};

export type Charge = {
  charge: Charge_charge | null
};


export type ChargeVariables = Exact<{
  input?: ChargeInput | null;
}>;

export type ChargeUserPayment_charge_paymentCandidate_currency = {
  __typename: 'Currency',
  _id: string | null,
  code: string | null
};

export type ChargeUserPayment_charge_paymentCandidate_policy_ratingsData = {
  __typename: 'KennelPolicyRatingsData',
  name: string | null
};

export type ChargeUserPayment_charge_paymentCandidate_policy = {
  __typename: 'KennelPolicy',
  ratingsData: ChargeUserPayment_charge_paymentCandidate_policy_ratingsData | null
};

export type ChargeUserPayment_charge_paymentCandidate_invoices = {
  __typename: 'KennelInvoice',
  _id: string,
  status: string | null,
  paidOn: string | null,
  issuedDate: string | null
};

export type ChargeUserPayment_charge_paymentCandidate_transactions = {
  __typename: 'PaymentTransaction',
  id: string | null,
  status: PaymentTransactionStatus | null,
  error: string | null,
  createdAt: string | null,
  updatedAt: string | null
};

export type ChargeUserPayment_charge_paymentCandidate_paymentPeriod = {
  __typename: 'PaymentPeriod',
  start: string | null,
  end: string | null
};

export type ChargeUserPayment_charge_paymentCandidate = {
  __typename: 'PaymentCandidate',
  id: string,
  amount: number | null,
  date: string | null,
  isFirstPayment: boolean | null,
  dunningEndDate: string | null,
  currency: ChargeUserPayment_charge_paymentCandidate_currency | null,
  policy: ChargeUserPayment_charge_paymentCandidate_policy | null,
  invoices: Array<ChargeUserPayment_charge_paymentCandidate_invoices> | null,
  transactions: Array<ChargeUserPayment_charge_paymentCandidate_transactions> | null,
  paymentPeriod: ChargeUserPayment_charge_paymentCandidate_paymentPeriod | null
};

export type ChargeUserPayment_charge_error = {
  __typename: 'ChargeResultError',
  code: string | null,
  message: string | null
};

export type ChargeUserPayment_charge = {
  __typename: 'ChargeResult',
  paymentCandidate: ChargeUserPayment_charge_paymentCandidate | null,
  error: ChargeUserPayment_charge_error | null
};

export type ChargeUserPayment = {
  charge: ChargeUserPayment_charge | null
};


export type ChargeUserPaymentVariables = Exact<{
  input?: ChargeInput | null;
}>;

export type SetupPaymentMethod_setupPaymentMethod_SetupPaymentMethodResultStripe = {
  __typename: 'SetupPaymentMethodResultStripe',
  clientSecret: string | null,
  checkoutUrl: string | null
};

export type SetupPaymentMethod_setupPaymentMethod_SetupPaymentMethodResultTrustly = {
  __typename: 'SetupPaymentMethodResultTrustly',
  url: string | null,
  orderId: string | null
};

export type SetupPaymentMethod_setupPaymentMethod =
  | SetupPaymentMethod_setupPaymentMethod_SetupPaymentMethodResultStripe
  | SetupPaymentMethod_setupPaymentMethod_SetupPaymentMethodResultTrustly
;

export type SetupPaymentMethod = {
  setupPaymentMethod: SetupPaymentMethod_setupPaymentMethod | null
};


export type SetupPaymentMethodVariables = Exact<{
  input?: SetupPaymentMethodInput | null;
}>;

export type SetupUserPaymentMethod_setupPaymentMethod_SetupPaymentMethodResultStripe = {
  __typename: 'SetupPaymentMethodResultStripe',
  clientSecret: string | null,
  checkoutUrl: string | null
};

export type SetupUserPaymentMethod_setupPaymentMethod_SetupPaymentMethodResultTrustly = {
  __typename: 'SetupPaymentMethodResultTrustly',
  url: string | null,
  orderId: string | null
};

export type SetupUserPaymentMethod_setupPaymentMethod =
  | SetupUserPaymentMethod_setupPaymentMethod_SetupPaymentMethodResultStripe
  | SetupUserPaymentMethod_setupPaymentMethod_SetupPaymentMethodResultTrustly
;

export type SetupUserPaymentMethod = {
  setupPaymentMethod: SetupUserPaymentMethod_setupPaymentMethod | null
};


export type SetupUserPaymentMethodVariables = Exact<{
  input?: SetupPaymentMethodInput | null;
}>;

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_policies_client_metadata = {
  __typename: 'KennelClientMetadata',
  payoutMethodId: string | null,
  payoutMethodProvider: string | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_policies_client = {
  __typename: 'KennelClient',
  metadata: CompleteSetupPaymentMethod_completeSetupPaymentMethod_policies_client_metadata | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_policies_paymentMethod = {
  __typename: 'KennelPolicyPaymentMethod',
  id: string,
  type: string | null,
  provider: PaymentMethodEnum
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_policies_payoutMethod = {
  __typename: 'KennelPolicyPayoutMethod',
  id: string,
  provider: PayoutMethodEnum
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_policies = {
  __typename: 'KennelPolicy',
  _id: string,
  client: CompleteSetupPaymentMethod_completeSetupPaymentMethod_policies_client | null,
  paymentMethod: CompleteSetupPaymentMethod_completeSetupPaymentMethod_policies_paymentMethod | null,
  payoutMethod: CompleteSetupPaymentMethod_completeSetupPaymentMethod_policies_payoutMethod | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_bacs_debit = {
  __typename: 'PaymentMethodStripeBacsDetails',
  last4: string | null,
  fingerprint: string | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeCard_card = {
  __typename: 'PaymentMethodStripeCardDetails',
  brand: string | null,
  last4: string | null,
  fingerprint: string | null,
  exp_month: number | null,
  exp_year: number | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeLink_link = {
  __typename: 'PaymentMethodStripeLinkDetails',
  email: string | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripePaypal_paypal = {
  __typename: 'PaymentMethodStripePaypalDetails',
  payer_id: string | null,
  payer_email: string | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeSepa_sepa_debit = {
  __typename: 'PaymentMethodStripeSepaDetails',
  last4: string | null,
  fingerprint: string | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeBacs = {
  __typename: 'PaymentMethodStripeBacs',
  id: string | null,
  bacs_debit: CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_bacs_debit | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeCard = {
  __typename: 'PaymentMethodStripeCard',
  id: string | null,
  card: CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeCard_card | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeLink = {
  __typename: 'PaymentMethodStripeLink',
  id: string | null,
  link: CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeLink_link | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripePaypal = {
  __typename: 'PaymentMethodStripePaypal',
  id: string | null,
  paypal: CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripePaypal_paypal | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeSepa = {
  __typename: 'PaymentMethodStripeSepa',
  id: string | null,
  sepa_debit: CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeSepa_sepa_debit | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodTrustly = {
  __typename: 'PaymentMethodTrustly',
  id: string | null,
  clearinghouse: string | null,
  bank: string | null,
  descriptor: string | null,
  lastdigits: string | null,
  verified: string | null,
  directdebitmandate: string | null,
  type: string | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods =
  | CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeBacs
  | CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeCard
  | CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeLink
  | CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripePaypal
  | CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeSepa
  | CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodTrustly
;

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodAtlar_identifiers = {
  __typename: 'PaymentMethodAtlarIdentifier',
  number: string | null,
  type: string | null,
  market: string | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_payoutMethods_PaymentMethodTrustly = {
  __typename: 'PaymentMethodTrustly',
  id: string | null,
  clearinghouse: string | null,
  bank: string | null,
  descriptor: string | null,
  lastdigits: string | null,
  verified: string | null,
  directdebitmandate: string | null,
  type: string | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodAtlar = {
  __typename: 'PayoutMethodAtlar',
  id: string | null,
  identifiers: Array<CompleteSetupPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodAtlar_identifiers> | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodPaypal = {
  __typename: 'PayoutMethodPaypal',
  id: string | null,
  email: string | null
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodSwish = {
  __typename: 'PayoutMethodSwish'
};

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod_payoutMethods =
  | CompleteSetupPaymentMethod_completeSetupPaymentMethod_payoutMethods_PaymentMethodTrustly
  | CompleteSetupPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodAtlar
  | CompleteSetupPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodPaypal
  | CompleteSetupPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodSwish
;

export type CompleteSetupPaymentMethod_completeSetupPaymentMethod = {
  __typename: 'PaymentPoliciesResult',
  policies: Array<CompleteSetupPaymentMethod_completeSetupPaymentMethod_policies> | null,
  paymentMethods: Array<CompleteSetupPaymentMethod_completeSetupPaymentMethod_paymentMethods> | null,
  payoutMethods: Array<CompleteSetupPaymentMethod_completeSetupPaymentMethod_payoutMethods> | null
};

export type CompleteSetupPaymentMethod = {
  completeSetupPaymentMethod: CompleteSetupPaymentMethod_completeSetupPaymentMethod | null
};


export type CompleteSetupPaymentMethodVariables = Exact<{
  input?: CompleteSetupPaymentMethodInput | null;
}>;

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_policies_client_metadata = {
  __typename: 'KennelClientMetadata',
  payoutMethodId: string | null,
  payoutMethodProvider: string | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_policies_client = {
  __typename: 'KennelClient',
  metadata: CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_policies_client_metadata | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_policies_paymentMethod = {
  __typename: 'KennelPolicyPaymentMethod',
  id: string,
  type: string | null,
  provider: PaymentMethodEnum
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_policies_payoutMethod = {
  __typename: 'KennelPolicyPayoutMethod',
  id: string,
  provider: PayoutMethodEnum
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_policies = {
  __typename: 'KennelPolicy',
  _id: string,
  client: CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_policies_client | null,
  paymentMethod: CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_policies_paymentMethod | null,
  payoutMethod: CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_policies_payoutMethod | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_bacs_debit = {
  __typename: 'PaymentMethodStripeBacsDetails',
  last4: string | null,
  fingerprint: string | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeCard_card = {
  __typename: 'PaymentMethodStripeCardDetails',
  brand: string | null,
  last4: string | null,
  fingerprint: string | null,
  exp_month: number | null,
  exp_year: number | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeLink_link = {
  __typename: 'PaymentMethodStripeLinkDetails',
  email: string | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripePaypal_paypal = {
  __typename: 'PaymentMethodStripePaypalDetails',
  payer_id: string | null,
  payer_email: string | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeSepa_sepa_debit = {
  __typename: 'PaymentMethodStripeSepaDetails',
  last4: string | null,
  fingerprint: string | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeBacs = {
  __typename: 'PaymentMethodStripeBacs',
  id: string | null,
  bacs_debit: CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_bacs_debit | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeCard = {
  __typename: 'PaymentMethodStripeCard',
  id: string | null,
  card: CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeCard_card | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeLink = {
  __typename: 'PaymentMethodStripeLink',
  id: string | null,
  link: CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeLink_link | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripePaypal = {
  __typename: 'PaymentMethodStripePaypal',
  id: string | null,
  paypal: CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripePaypal_paypal | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeSepa = {
  __typename: 'PaymentMethodStripeSepa',
  id: string | null,
  sepa_debit: CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeSepa_sepa_debit | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodTrustly = {
  __typename: 'PaymentMethodTrustly',
  id: string | null,
  clearinghouse: string | null,
  bank: string | null,
  descriptor: string | null,
  lastdigits: string | null,
  verified: string | null,
  directdebitmandate: string | null,
  type: string | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods =
  | CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeBacs
  | CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeCard
  | CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeLink
  | CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripePaypal
  | CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodStripeSepa
  | CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods_PaymentMethodTrustly
;

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodAtlar_identifiers = {
  __typename: 'PaymentMethodAtlarIdentifier',
  number: string | null,
  type: string | null,
  market: string | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_payoutMethods_PaymentMethodTrustly = {
  __typename: 'PaymentMethodTrustly',
  id: string | null,
  clearinghouse: string | null,
  bank: string | null,
  descriptor: string | null,
  lastdigits: string | null,
  verified: string | null,
  directdebitmandate: string | null,
  type: string | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodAtlar = {
  __typename: 'PayoutMethodAtlar',
  id: string | null,
  identifiers: Array<CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodAtlar_identifiers> | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodPaypal = {
  __typename: 'PayoutMethodPaypal',
  id: string | null,
  email: string | null
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodSwish = {
  __typename: 'PayoutMethodSwish'
};

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_payoutMethods =
  | CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_payoutMethods_PaymentMethodTrustly
  | CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodAtlar
  | CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodPaypal
  | CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_payoutMethods_PayoutMethodSwish
;

export type CompleteSetupUserPaymentMethod_completeSetupPaymentMethod = {
  __typename: 'PaymentPoliciesResult',
  policies: Array<CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_policies> | null,
  paymentMethods: Array<CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_paymentMethods> | null,
  payoutMethods: Array<CompleteSetupUserPaymentMethod_completeSetupPaymentMethod_payoutMethods> | null
};

export type CompleteSetupUserPaymentMethod = {
  completeSetupPaymentMethod: CompleteSetupUserPaymentMethod_completeSetupPaymentMethod | null
};


export type CompleteSetupUserPaymentMethodVariables = Exact<{
  input?: CompleteSetupPaymentMethodInput | null;
}>;

export type SetUkPayoutAccount_setUkPayoutAccount = {
  __typename: 'KennelClient',
  _id: string
};

export type SetUkPayoutAccount = {
  setUkPayoutAccount: SetUkPayoutAccount_setUkPayoutAccount | null
};


export type SetUkPayoutAccountVariables = Exact<{
  input: SetUkPayoutAccountInput;
}>;

export type SetUkUserPayoutAccount_setUkUserPayoutAccount = {
  __typename: 'KennelClient',
  _id: string
};

export type SetUkUserPayoutAccount = {
  setUkUserPayoutAccount: SetUkUserPayoutAccount_setUkUserPayoutAccount | null
};


export type SetUkUserPayoutAccountVariables = Exact<{
  input: SetUkPayoutAccountInput;
}>;

export type ChangePaymentMethod_changePaymentMethod_client_metadata = {
  __typename: 'KennelClientMetadata',
  payoutMethodId: string | null,
  payoutMethodProvider: string | null
};

export type ChangePaymentMethod_changePaymentMethod_client = {
  __typename: 'KennelClient',
  _id: string,
  metadata: ChangePaymentMethod_changePaymentMethod_client_metadata | null
};

export type ChangePaymentMethod_changePaymentMethod_paymentMethod = {
  __typename: 'KennelPolicyPaymentMethod',
  id: string,
  type: string | null,
  provider: PaymentMethodEnum
};

export type ChangePaymentMethod_changePaymentMethod_payoutMethod = {
  __typename: 'KennelPolicyPayoutMethod',
  id: string,
  provider: PayoutMethodEnum
};

export type ChangePaymentMethod_changePaymentMethod = {
  __typename: 'KennelPolicy',
  _id: string,
  client: ChangePaymentMethod_changePaymentMethod_client | null,
  paymentMethod: ChangePaymentMethod_changePaymentMethod_paymentMethod | null,
  payoutMethod: ChangePaymentMethod_changePaymentMethod_payoutMethod | null
};

export type ChangePaymentMethod = {
  changePaymentMethod: Array<ChangePaymentMethod_changePaymentMethod> | null
};


export type ChangePaymentMethodVariables = Exact<{
  input?: ChangePaymentMethodInput | null;
}>;

export type ChangeUserPaymentMethod_changePaymentMethod_client_metadata = {
  __typename: 'KennelClientMetadata',
  payoutMethodId: string | null,
  payoutMethodProvider: string | null
};

export type ChangeUserPaymentMethod_changePaymentMethod_client = {
  __typename: 'KennelClient',
  _id: string,
  metadata: ChangeUserPaymentMethod_changePaymentMethod_client_metadata | null
};

export type ChangeUserPaymentMethod_changePaymentMethod_paymentMethod = {
  __typename: 'KennelPolicyPaymentMethod',
  id: string,
  type: string | null,
  provider: PaymentMethodEnum
};

export type ChangeUserPaymentMethod_changePaymentMethod_payoutMethod = {
  __typename: 'KennelPolicyPayoutMethod',
  id: string,
  provider: PayoutMethodEnum
};

export type ChangeUserPaymentMethod_changePaymentMethod = {
  __typename: 'KennelPolicy',
  _id: string,
  client: ChangeUserPaymentMethod_changePaymentMethod_client | null,
  paymentMethod: ChangeUserPaymentMethod_changePaymentMethod_paymentMethod | null,
  payoutMethod: ChangeUserPaymentMethod_changePaymentMethod_payoutMethod | null
};

export type ChangeUserPaymentMethod = {
  changePaymentMethod: Array<ChangeUserPaymentMethod_changePaymentMethod> | null
};


export type ChangeUserPaymentMethodVariables = Exact<{
  input?: ChangePaymentMethodInput | null;
}>;

export type ChangePayoutMethod_changePayoutMethod_metadata = {
  __typename: 'KennelClientMetadata',
  payoutMethodId: string | null,
  payoutMethodProvider: string | null
};

export type ChangePayoutMethod_changePayoutMethod = {
  __typename: 'KennelClient',
  _id: string,
  metadata: ChangePayoutMethod_changePayoutMethod_metadata | null
};

export type ChangePayoutMethod = {
  changePayoutMethod: ChangePayoutMethod_changePayoutMethod | null
};


export type ChangePayoutMethodVariables = Exact<{
  input?: ChangePayoutMethodInput | null;
}>;

export type ChangeUserPayoutMethod_changePayoutMethod_metadata = {
  __typename: 'KennelClientMetadata',
  payoutMethodId: string | null,
  payoutMethodProvider: string | null
};

export type ChangeUserPayoutMethod_changePayoutMethod = {
  __typename: 'KennelClient',
  _id: string,
  metadata: ChangeUserPayoutMethod_changePayoutMethod_metadata | null
};

export type ChangeUserPayoutMethod = {
  changePayoutMethod: ChangeUserPayoutMethod_changePayoutMethod | null
};


export type ChangeUserPayoutMethodVariables = Exact<{
  input?: ChangePayoutMethodInput | null;
}>;

export type RemovePaymentMethod_removePaymentMethod_PaymentMethodStripePaypal_paypal = {
  __typename: 'PaymentMethodStripePaypalDetails',
  payer_id: string | null,
  payer_email: string | null
};

export type RemovePaymentMethod_removePaymentMethod_PaymentMethodStripeBacs = {
  __typename: 'PaymentMethodStripeBacs',
  id: string | null
};

export type RemovePaymentMethod_removePaymentMethod_PaymentMethodStripeCard = {
  __typename: 'PaymentMethodStripeCard',
  id: string | null
};

export type RemovePaymentMethod_removePaymentMethod_PaymentMethodStripeLink = {
  __typename: 'PaymentMethodStripeLink',
  id: string | null
};

export type RemovePaymentMethod_removePaymentMethod_PaymentMethodStripePaypal = {
  __typename: 'PaymentMethodStripePaypal',
  id: string | null,
  paypal: RemovePaymentMethod_removePaymentMethod_PaymentMethodStripePaypal_paypal | null
};

export type RemovePaymentMethod_removePaymentMethod_PaymentMethodStripeSepa = {
  __typename: 'PaymentMethodStripeSepa',
  id: string | null
};

export type RemovePaymentMethod_removePaymentMethod_PaymentMethodTrustly = {
  __typename: 'PaymentMethodTrustly',
  id: string | null
};

export type RemovePaymentMethod_removePaymentMethod =
  | RemovePaymentMethod_removePaymentMethod_PaymentMethodStripeBacs
  | RemovePaymentMethod_removePaymentMethod_PaymentMethodStripeCard
  | RemovePaymentMethod_removePaymentMethod_PaymentMethodStripeLink
  | RemovePaymentMethod_removePaymentMethod_PaymentMethodStripePaypal
  | RemovePaymentMethod_removePaymentMethod_PaymentMethodStripeSepa
  | RemovePaymentMethod_removePaymentMethod_PaymentMethodTrustly
;

export type RemovePaymentMethod = {
  removePaymentMethod: Array<RemovePaymentMethod_removePaymentMethod> | null
};


export type RemovePaymentMethodVariables = Exact<{
  input?: RemovePaymentMethodInput | null;
}>;

export type RemoveUserPaymentMethod_removePaymentMethod_PaymentMethodStripePaypal_paypal = {
  __typename: 'PaymentMethodStripePaypalDetails',
  payer_id: string | null,
  payer_email: string | null
};

export type RemoveUserPaymentMethod_removePaymentMethod_PaymentMethodStripeBacs = {
  __typename: 'PaymentMethodStripeBacs',
  id: string | null
};

export type RemoveUserPaymentMethod_removePaymentMethod_PaymentMethodStripeCard = {
  __typename: 'PaymentMethodStripeCard',
  id: string | null
};

export type RemoveUserPaymentMethod_removePaymentMethod_PaymentMethodStripeLink = {
  __typename: 'PaymentMethodStripeLink',
  id: string | null
};

export type RemoveUserPaymentMethod_removePaymentMethod_PaymentMethodStripePaypal = {
  __typename: 'PaymentMethodStripePaypal',
  id: string | null,
  paypal: RemoveUserPaymentMethod_removePaymentMethod_PaymentMethodStripePaypal_paypal | null
};

export type RemoveUserPaymentMethod_removePaymentMethod_PaymentMethodStripeSepa = {
  __typename: 'PaymentMethodStripeSepa',
  id: string | null
};

export type RemoveUserPaymentMethod_removePaymentMethod_PaymentMethodTrustly = {
  __typename: 'PaymentMethodTrustly',
  id: string | null
};

export type RemoveUserPaymentMethod_removePaymentMethod =
  | RemoveUserPaymentMethod_removePaymentMethod_PaymentMethodStripeBacs
  | RemoveUserPaymentMethod_removePaymentMethod_PaymentMethodStripeCard
  | RemoveUserPaymentMethod_removePaymentMethod_PaymentMethodStripeLink
  | RemoveUserPaymentMethod_removePaymentMethod_PaymentMethodStripePaypal
  | RemoveUserPaymentMethod_removePaymentMethod_PaymentMethodStripeSepa
  | RemoveUserPaymentMethod_removePaymentMethod_PaymentMethodTrustly
;

export type RemoveUserPaymentMethod = {
  removePaymentMethod: Array<RemoveUserPaymentMethod_removePaymentMethod> | null
};


export type RemoveUserPaymentMethodVariables = Exact<{
  input?: RemovePaymentMethodInput | null;
}>;

export type ValidateEurobonusMemberId = {
  validateEurobonusMemberId: boolean | null
};


export type ValidateEurobonusMemberIdVariables = Exact<{
  memberId?: string | null;
}>;

export type ValidateLunarMemberId = {
  validateLunarMemberId: boolean | null
};


export type ValidateLunarMemberIdVariables = Exact<{
  memberId?: string | null;
}>;

export type CheckMultiBind_checkMultiBind_policy_client_metadata = {
  __typename: 'KennelClientMetadata',
  municipality: string | null
};

export type CheckMultiBind_checkMultiBind_policy_client = {
  __typename: 'KennelClient',
  _id: string,
  email: string,
  metadata: CheckMultiBind_checkMultiBind_policy_client_metadata | null
};

export type CheckMultiBind_checkMultiBind_policy_metadata = {
  __typename: 'KennelPolicyMetadata',
  discount: string | null,
  cancelPreviousInsurance: string | null,
  previousInsurance: string | null,
  imported: string | null
};

export type CheckMultiBind_checkMultiBind_policy_copays = {
  __typename: 'KennelCopay',
  total: number | null
};

export type CheckMultiBind_checkMultiBind_policy_ratingsData = {
  __typename: 'KennelPolicyRatingsData',
  name: string | null,
  breed: string | null,
  lifeLimit: number | null,
  birthday: string | null,
  sex: string | null,
  copay: number | null,
  breedersAddOn: boolean | null,
  lifeUtilityAddOn: string | null,
  access: string | null
};

export type CheckMultiBind_checkMultiBind_policy_discounts = {
  __typename: 'KennelDiscount',
  maxInvoicesSpread: number | null,
  name: string,
  type: DiscountType,
  total: number | null
};

export type CheckMultiBind_checkMultiBind_policy_currency = {
  __typename: 'Currency',
  name: string | null,
  code: string | null,
  symbol: string | null
};

export type CheckMultiBind_checkMultiBind_policy = {
  __typename: 'KennelPolicy',
  _id: string,
  netPremium: number,
  termPremium: number,
  billingInterval: number,
  billingDay: number | null,
  total: number | null,
  deductible: number,
  effectiveDate: string,
  limit: number,
  planName: string,
  policyNumber: string,
  productName: ProductEnum,
  client: CheckMultiBind_checkMultiBind_policy_client | null,
  metadata: CheckMultiBind_checkMultiBind_policy_metadata | null,
  copays: Array<CheckMultiBind_checkMultiBind_policy_copays> | null,
  ratingsData: CheckMultiBind_checkMultiBind_policy_ratingsData | null,
  discounts: Array<CheckMultiBind_checkMultiBind_policy_discounts>,
  currency: CheckMultiBind_checkMultiBind_policy_currency | null
};

export type CheckMultiBind_checkMultiBind = {
  __typename: 'CheckMultiBind',
  _id: string,
  policy: CheckMultiBind_checkMultiBind_policy | null
};

export type CheckMultiBind = {
  checkMultiBind: Array<CheckMultiBind_checkMultiBind> | null
};


export type CheckMultiBindVariables = Exact<{
  input?: CheckMultiBindInput | null;
}>;

export type InitMultiBind_initMultiBind_SetupPaymentMethodResultStripe = {
  __typename: 'SetupPaymentMethodResultStripe',
  clientSecret: string | null
};

export type InitMultiBind_initMultiBind_SetupPaymentMethodResultTrustly = {
  __typename: 'SetupPaymentMethodResultTrustly',
  url: string | null
};

export type InitMultiBind_initMultiBind =
  | InitMultiBind_initMultiBind_SetupPaymentMethodResultStripe
  | InitMultiBind_initMultiBind_SetupPaymentMethodResultTrustly
;

export type InitMultiBind = {
  initMultiBind: InitMultiBind_initMultiBind | null
};


export type InitMultiBindVariables = Exact<{
  input?: InitMultiBindInput | null;
}>;

export type CareEligibility_appProducts = {
  __typename: 'AppProduct',
  slug: string,
  eligibleSpecies: Array<SpeciesEnum> | null
};

export type CareEligibility = {
  appProducts: Array<CareEligibility_appProducts>
};


export type CareEligibilityVariables = Exact<{ [key: string]: never; }>;

export type SearchPostcodes_searchPostcodes_results = {
  __typename: 'PostCode',
  value: string,
  text: string,
  code: string
};

export type SearchPostcodes_searchPostcodes = {
  __typename: 'PostCodesSearchResult',
  results: Array<SearchPostcodes_searchPostcodes_results>
};

export type SearchPostcodes = {
  searchPostcodes: SearchPostcodes_searchPostcodes | null
};


export type SearchPostcodesVariables = Exact<{
  input: string;
}>;

export type UseIsSignaturePresent = {
  isSignaturePresent: boolean | null
};


export type UseIsSignaturePresentVariables = Exact<{
  input?: IsSignaturePresentInput | null;
}>;

export type AppProducts_appProducts_pricing = {
  __typename: 'AppProductPricing',
  currency: string,
  interval: string,
  pricePerAnimal: number
};

export type AppProducts_appProducts_features = {
  __typename: 'AppProductFeature',
  key: string,
  hasSubtitle: boolean | null
};

export type AppProducts_appProducts_budget = {
  __typename: 'AppProductBudget',
  currency: string,
  annualAmountPerAnimal: number
};

export type AppProducts_appProducts = {
  __typename: 'AppProduct',
  name: string,
  slug: string,
  version: string,
  status: string,
  billingScope: string,
  priceFor: number,
  eligibleSpecies: Array<SpeciesEnum> | null,
  pricing: Array<AppProducts_appProducts_pricing>,
  features: Array<AppProducts_appProducts_features>,
  budget: AppProducts_appProducts_budget | null
};

export type AppProducts = {
  appProducts: Array<AppProducts_appProducts>
};


export type AppProductsVariables = Exact<{
  quantity: number;
  interval: string;
}>;

export type GetBreedDataListForServerSideData_getBreedDataList = {
  __typename: 'BreedData',
  ids: Array<string>,
  displayNames: Array<string>,
  type: BreedType | null,
  restrictedFromMarket: boolean | null,
  liabilityInsurable: boolean | null,
  lifeSignupMaxAgeMonths: number | null,
  lifeRenewalMaxAgeMonths: number | null
};

export type GetBreedDataListForServerSideData = {
  getBreedDataList: Array<GetBreedDataListForServerSideData_getBreedDataList> | null
};


export type GetBreedDataListForServerSideDataVariables = Exact<{
  input: GetBreedsInput;
}>;

export type ResumeDraft_resumeDraft_client_addresses = {
  __typename: 'KennelAddress',
  city: string | null,
  line1: string | null,
  line2: string | null,
  zip: string | null
};

export type ResumeDraft_resumeDraft_client_metadata = {
  __typename: 'KennelClientMetadata',
  ssn: string | null,
  allowMarketing: string | null,
  acceptedAssumptions: string | null,
  acceptedDeclarations: string | null,
  birthdate: string | null,
  userId: string | null
};

export type ResumeDraft_resumeDraft_client = {
  __typename: 'KennelClient',
  name: string,
  firstName: string | null,
  lastName: string | null,
  email: string,
  phone: string | null,
  addresses: Array<ResumeDraft_resumeDraft_client_addresses> | null,
  metadata: ResumeDraft_resumeDraft_client_metadata | null
};

export type ResumeDraft_resumeDraft_addressDraft = {
  __typename: 'KennelAddressDraft',
  city: string | null,
  line1: string | null,
  line2: string | null,
  zip: string
};

export type ResumeDraft_resumeDraft_policyDrafts_metadata = {
  __typename: 'KennelPolicyMetadata',
  animalId: string | null,
  draftAnimalId: string | null,
  discount: string | null,
  cancelPreviousInsurance: string | null,
  insuranceHistory: string | null,
  previousInsurance: string | null,
  healthHistory: string | null,
  customerSignature: string | null,
  compare: string | null,
  partner: string | null,
  attribution: string | null,
  imported: string | null,
  microchipped: string | null,
  purchasePrice: number | null
};

export type ResumeDraft_resumeDraft_policyDrafts_ratingsData_breedData = {
  __typename: 'KennelPolicyBreedData',
  type: BreedType,
  breedIds: Array<string>,
  displayNames: Array<string>,
  mixedBreedWeight: MixedBreedWeight | null,
  mixedBreedHeight: MixedBreedHeight | null
};

export type ResumeDraft_resumeDraft_policyDrafts_ratingsData_breedersAddOnLitter = {
  __typename: 'KennelPolicyRatingsDataBreedersAddOnLitter',
  name: string | null,
  price: number | null,
  birthDate: string | null
};

export type ResumeDraft_resumeDraft_policyDrafts_ratingsData = {
  __typename: 'KennelPolicyRatingsData',
  name: string | null,
  lifeUtilityAddOn: string | null,
  access: string | null,
  clientBirthdate: string | null,
  liabilityBestAddOn: boolean | null,
  liabilitySosAddOn: boolean | null,
  liabilityRentedAddOn: boolean | null,
  preexistingConditions: boolean | null,
  preventiveCareAddOnLimit: number | null,
  breed: string | null,
  sex: string | null,
  birthday: string | null,
  copay: number | null,
  lifeLimit: number | null,
  region: string | null,
  municipality: string | null,
  breedersAddOn: boolean | null,
  breedData: ResumeDraft_resumeDraft_policyDrafts_ratingsData_breedData | null,
  breedersAddOnLitter: Array<ResumeDraft_resumeDraft_policyDrafts_ratingsData_breedersAddOnLitter> | null
};

export type ResumeDraft_resumeDraft_policyDrafts = {
  __typename: 'KennelPolicyDraft',
  _id: string,
  billingInterval: number,
  billingDay: number | null,
  effectiveDate: string,
  limit: number,
  selectedPlan: string | null,
  deductible: number,
  productName: ProductEnum,
  metadata: ResumeDraft_resumeDraft_policyDrafts_metadata,
  ratingsData: ResumeDraft_resumeDraft_policyDrafts_ratingsData
};

export type ResumeDraft_resumeDraft = {
  __typename: 'KennelDraft',
  _id: string,
  clientId: string | null,
  client: ResumeDraft_resumeDraft_client | null,
  addressDraft: ResumeDraft_resumeDraft_addressDraft | null,
  policyDrafts: Array<ResumeDraft_resumeDraft_policyDrafts>
};

export type ResumeDraft = {
  resumeDraft: ResumeDraft_resumeDraft | null
};


export type ResumeDraftVariables = Exact<{
  input: ResumeDraftInput;
}>;

export type UpsertDraft_upsertDraft_client_addresses = {
  __typename: 'KennelAddress',
  city: string | null,
  line1: string | null,
  line2: string | null,
  zip: string | null
};

export type UpsertDraft_upsertDraft_client = {
  __typename: 'KennelClient',
  name: string,
  email: string,
  phone: string | null,
  addresses: Array<UpsertDraft_upsertDraft_client_addresses> | null
};

export type UpsertDraft_upsertDraft_policyPreviews_plans_coverages = {
  __typename: 'PolicyPreviewPlanCoverage',
  coverageGroupId: string,
  limit: number,
  name: string,
  premium: number
};

export type UpsertDraft_upsertDraft_policyPreviews_plans_ratingsData = {
  __typename: 'KennelPolicyRatingsData',
  preexistingConditions: boolean | null
};

export type UpsertDraft_upsertDraft_policyPreviews_plans_discounts = {
  __typename: 'PolicyPreviewPlanDiscount',
  maxInvoicesSpread: number | null,
  applicationTotal: number,
  applicationType: DiscountApplicationType,
  name: string,
  type: DiscountType,
  total: number
};

export type UpsertDraft_upsertDraft_policyPreviews_plans_fees = {
  __typename: 'PolicyPreviewPlanFee',
  maxInvoicesSpread: number | null,
  name: string | null,
  total: number | null,
  type: string | null
};

export type UpsertDraft_upsertDraft_policyPreviews_plans = {
  __typename: 'PolicyPreviewPlan',
  deductible: number,
  limit: number,
  netPremium: number,
  total: number,
  copay: number | null,
  name: string,
  coverages: Array<UpsertDraft_upsertDraft_policyPreviews_plans_coverages> | null,
  ratingsData: UpsertDraft_upsertDraft_policyPreviews_plans_ratingsData | null,
  discounts: Array<UpsertDraft_upsertDraft_policyPreviews_plans_discounts> | null,
  fees: Array<UpsertDraft_upsertDraft_policyPreviews_plans_fees> | null
};

export type UpsertDraft_upsertDraft_policyPreviews_error = {
  __typename: 'PolicyPreviewError',
  message: string | null
};

export type UpsertDraft_upsertDraft_policyPreviews = {
  __typename: 'PolicyPreview',
  _id: string,
  plans: Array<UpsertDraft_upsertDraft_policyPreviews_plans> | null,
  error: UpsertDraft_upsertDraft_policyPreviews_error | null
};

export type UpsertDraft_upsertDraft = {
  __typename: 'DraftPreview',
  _id: string,
  clientId: string | null,
  client: UpsertDraft_upsertDraft_client | null,
  policyPreviews: Array<UpsertDraft_upsertDraft_policyPreviews> | null
};

export type UpsertDraft = {
  upsertDraft: UpsertDraft_upsertDraft | null
};


export type UpsertDraftVariables = Exact<{
  input: UpsertDraftInput;
}>;

export type FaqItemCollection_faqItemCollection_items_answer = {
  __typename: 'FaqItemAnswer',
  json: any
};

export type FaqItemCollection_faqItemCollection_items_contentfulMetadata_tags = {
  __typename: 'ContentfulTag',
  id: string | null,
  name: string | null
};

export type FaqItemCollection_faqItemCollection_items_contentfulMetadata = {
  __typename: 'ContentfulMetadata',
  tags: Array<FaqItemCollection_faqItemCollection_items_contentfulMetadata_tags | null>
};

export type FaqItemCollection_faqItemCollection_items_sys = {
  __typename: 'Sys',
  id: string
};

export type FaqItemCollection_faqItemCollection_items = {
  __typename: 'FaqItem',
  question: string | null,
  answer: FaqItemCollection_faqItemCollection_items_answer | null,
  contentfulMetadata: FaqItemCollection_faqItemCollection_items_contentfulMetadata,
  sys: FaqItemCollection_faqItemCollection_items_sys
};

export type FaqItemCollection_faqItemCollection = {
  __typename: 'FaqItemCollection',
  items: Array<FaqItemCollection_faqItemCollection_items | null>
};

export type FaqItemCollection = {
  faqItemCollection: FaqItemCollection_faqItemCollection | null
};


export type FaqItemCollectionVariables = Exact<{
  where?: FaqItemFilter | null;
  locale: string;
}>;

export type SiteNavigation_siteCollection_items_navigationCollection_items_page = {
  __typename: 'Page',
  slug: string | null
};

export type SiteNavigation_siteCollection_items_navigationCollection_items_url = {
  __typename: 'Url',
  url: string | null
};

export type SiteNavigation_siteCollection_items_navigationCollection_items = {
  __typename: 'NavigationItem',
  title: string | null,
  group: string | null,
  groupLevel: string | null,
  page: SiteNavigation_siteCollection_items_navigationCollection_items_page | null,
  url: SiteNavigation_siteCollection_items_navigationCollection_items_url | null
};

export type SiteNavigation_siteCollection_items_navigationCollection = {
  __typename: 'SiteNavigationCollection',
  items: Array<SiteNavigation_siteCollection_items_navigationCollection_items | null>
};

export type SiteNavigation_siteCollection_items = {
  __typename: 'Site',
  navigationCollection: SiteNavigation_siteCollection_items_navigationCollection | null
};

export type SiteNavigation_siteCollection = {
  __typename: 'SiteCollection',
  items: Array<SiteNavigation_siteCollection_items | null>
};

export type SiteNavigation = {
  siteCollection: SiteNavigation_siteCollection | null
};


export type SiteNavigationVariables = Exact<{
  domain?: string | null;
  locale?: string | null;
}>;

export type SiteLocales_siteCollection_items = {
  __typename: 'Site',
  locales: Array<string | null> | null
};

export type SiteLocales_siteCollection = {
  __typename: 'SiteCollection',
  items: Array<SiteLocales_siteCollection_items | null>
};

export type SiteLocales = {
  siteCollection: SiteLocales_siteCollection | null
};


export type SiteLocalesVariables = Exact<{
  domain?: string | null;
}>;

export type PublishedPages_pageCollection_items_linkedFrom_siteCollection_items_sys = {
  __typename: 'Sys',
  id: string
};

export type PublishedPages_pageCollection_items_linkedFrom_siteCollection_items = {
  __typename: 'Site',
  sys: PublishedPages_pageCollection_items_linkedFrom_siteCollection_items_sys
};

export type PublishedPages_pageCollection_items_linkedFrom_siteCollection = {
  __typename: 'SiteCollection',
  items: Array<PublishedPages_pageCollection_items_linkedFrom_siteCollection_items | null>
};

export type PublishedPages_pageCollection_items_linkedFrom = {
  __typename: 'PageLinkingCollections',
  siteCollection: PublishedPages_pageCollection_items_linkedFrom_siteCollection | null
};

export type PublishedPages_pageCollection_items_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any
};

export type PublishedPages_pageCollection_items = {
  __typename: 'Page',
  slug: string | null,
  seoNoIndex: boolean | null,
  linkedFrom: PublishedPages_pageCollection_items_linkedFrom | null,
  sys: PublishedPages_pageCollection_items_sys
};

export type PublishedPages_pageCollection = {
  __typename: 'PageCollection',
  items: Array<PublishedPages_pageCollection_items | null>
};

export type PublishedPages = {
  pageCollection: PublishedPages_pageCollection | null
};


export type PublishedPagesVariables = Exact<{
  locale?: string | null;
}>;

export type Site_siteCollection_items_sys = {
  __typename: 'Sys',
  id: string
};

export type Site_siteCollection_items = {
  __typename: 'Site',
  domain: string | null,
  locales: Array<string | null> | null,
  sys: Site_siteCollection_items_sys
};

export type Site_siteCollection = {
  __typename: 'SiteCollection',
  items: Array<Site_siteCollection_items | null>
};

export type Site = {
  siteCollection: Site_siteCollection | null
};


export type SiteVariables = Exact<{
  domain?: string | null;
  locale?: string | null;
}>;

export type ArticleListArticles_componentArticleList_articlesCollection_items_sys = {
  __typename: 'Sys',
  id: string
};

export type ArticleListArticles_componentArticleList_articlesCollection_items = {
  __typename: 'Article',
  uri: string | null,
  sys: ArticleListArticles_componentArticleList_articlesCollection_items_sys
};

export type ArticleListArticles_componentArticleList_articlesCollection = {
  __typename: 'ComponentArticleListArticlesCollection',
  items: Array<ArticleListArticles_componentArticleList_articlesCollection_items | null>
};

export type ArticleListArticles_componentArticleList = {
  __typename: 'ComponentArticleList',
  articlesCollection: ArticleListArticles_componentArticleList_articlesCollection | null
};

export type ArticleListArticles = {
  componentArticleList: ArticleListArticles_componentArticleList | null
};


export type ArticleListArticlesVariables = Exact<{
  id: string;
  locale: string;
}>;

export type PageId_pageCollection_items_sys = {
  __typename: 'Sys',
  id: string
};

export type PageId_pageCollection_items_linkedFrom_siteCollection_items = {
  __typename: 'Site',
  domain: string | null
};

export type PageId_pageCollection_items_linkedFrom_siteCollection = {
  __typename: 'SiteCollection',
  items: Array<PageId_pageCollection_items_linkedFrom_siteCollection_items | null>
};

export type PageId_pageCollection_items_linkedFrom = {
  __typename: 'PageLinkingCollections',
  siteCollection: PageId_pageCollection_items_linkedFrom_siteCollection | null
};

export type PageId_pageCollection_items = {
  __typename: 'Page',
  internalName: string | null,
  sys: PageId_pageCollection_items_sys,
  linkedFrom: PageId_pageCollection_items_linkedFrom | null
};

export type PageId_pageCollection = {
  __typename: 'PageCollection',
  items: Array<PageId_pageCollection_items | null>
};

export type PageId = {
  pageCollection: PageId_pageCollection | null
};


export type PageIdVariables = Exact<{
  id?: string | null;
  slug?: string | null;
  locale?: string | null;
  preview?: boolean | null;
}>;

export type GetPageSlugsBySlug_pageSlugsBySlug = {
  __typename: 'PageSlugsResult',
  locale: string,
  uri: string,
  org: string
};

export type GetPageSlugsBySlug = {
  pageSlugsBySlug: Array<GetPageSlugsBySlug_pageSlugsBySlug | null> | null
};


export type GetPageSlugsBySlugVariables = Exact<{
  slug: string;
}>;

export type GetArticlePageSlugsById_articlePageSlugsById = {
  __typename: 'PageSlugsResult',
  locale: string,
  uri: string,
  org: string
};

export type GetArticlePageSlugsById = {
  articlePageSlugsById: Array<GetArticlePageSlugsById_articlePageSlugsById | null> | null
};


export type GetArticlePageSlugsByIdVariables = Exact<{
  id: string;
}>;

export type Page_page_content_componentsCollection_items_Component = {
  __typename: 'Component'
};

export type Page_page_content_componentsCollection_items_ComponentArticleList = {
  __typename: 'ComponentArticleList',
  sys: ArticleList_sys
};

export type Page_page_content_componentsCollection_items_ComponentColumns = {
  __typename: 'ComponentColumns'
};

export type Page_page_content_componentsCollection_items_ComponentFactBlock = {
  __typename: 'ComponentFactBlock'
};

export type Page_page_content_componentsCollection_items_ComponentFaq = {
  __typename: 'ComponentFaq'
};

export type Page_page_content_componentsCollection_items_ComponentFirstVetCard = {
  __typename: 'ComponentFirstVetCard'
};

export type Page_page_content_componentsCollection_items_ComponentGutter = {
  __typename: 'ComponentGutter'
};

export type Page_page_content_componentsCollection_items_ComponentHero = {
  __typename: 'ComponentHero'
};

export type Page_page_content_componentsCollection_items_ComponentPackages = {
  __typename: 'ComponentPackages'
};

export type Page_page_content_componentsCollection_items_ComponentTextAndMedia = {
  __typename: 'ComponentTextAndMedia'
};

export type Page_page_content_componentsCollection_items =
  | Page_page_content_componentsCollection_items_Component
  | Page_page_content_componentsCollection_items_ComponentArticleList
  | Page_page_content_componentsCollection_items_ComponentColumns
  | Page_page_content_componentsCollection_items_ComponentFactBlock
  | Page_page_content_componentsCollection_items_ComponentFaq
  | Page_page_content_componentsCollection_items_ComponentFirstVetCard
  | Page_page_content_componentsCollection_items_ComponentGutter
  | Page_page_content_componentsCollection_items_ComponentHero
  | Page_page_content_componentsCollection_items_ComponentPackages
  | Page_page_content_componentsCollection_items_ComponentTextAndMedia
;

export type Page_page_content_componentsCollection = {
  __typename: 'PageContentComponentsCollection',
  items: Array<Page_page_content_componentsCollection_items | null>
};

export type Page_page_content = {
  __typename: 'PageContent',
  componentsCollection: Page_page_content_componentsCollection | null
};

export type Page_page_bodyCollection_items_Component = {
  __typename: 'Component',
  highlight: string | null,
  title: string | null,
  type: string | null,
  theme: string | null,
  props: any,
  c2A: Component_c2A | null,
  sys: Component_sys
};

export type Page_page_bodyCollection_items_ComponentBenefits = {
  __typename: 'ComponentBenefits',
  highlight: string | null,
  title: string | null,
  text: string | null,
  benefitLayout: boolean | null,
  listLayout: boolean | null,
  variation: string | null,
  benefitItemsCollection: Benefits_benefitItemsCollection | null,
  c2A: Benefits_c2A | null,
  sys: Benefits_sys
};

export type Page_page_bodyCollection_items_ComponentCards = {
  __typename: 'ComponentCards',
  highlight: string | null,
  title: string | null,
  text: string | null,
  cardsCollection: Cards_cardsCollection | null,
  c2A: Cards_c2A | null,
  sys: Cards_sys
};

export type Page_page_bodyCollection_items_ComponentFaq = {
  __typename: 'ComponentFaq',
  highlight: string | null,
  title: string | null,
  text: string | null,
  tagId: string | null,
  itemsCollection: FAQ_itemsCollection | null,
  c2A: FAQ_c2A | null,
  sys: FAQ_sys
};

export type Page_page_bodyCollection_items_ComponentHero = {
  __typename: 'ComponentHero',
  type: string | null,
  title: string | null,
  text: string | null,
  disclaimer: string | null,
  theme: string | null,
  hideButtons: boolean | null,
  c2A: Hero_c2A | null,
  listItemsCollection: Hero_listItemsCollection | null,
  badgesCollection: Hero_badgesCollection | null,
  thumbnail: Hero_thumbnail | null,
  media: Hero_media | null,
  desktopPosterImage: Hero_desktopPosterImage | null,
  mobilePosterImage: Hero_mobilePosterImage | null,
  sys: Hero_sys
};

export type Page_page_bodyCollection_items_ComponentPackages = {
  __typename: 'ComponentPackages',
  products: Array<string | null> | null,
  layout: boolean | null,
  highlight: string | null,
  title: string | null,
  text: string | null,
  theme: string | null,
  c2A: Packages_c2A | null,
  sys: Packages_sys
};

export type Page_page_bodyCollection_items_ComponentPromoBanner = {
  __typename: 'ComponentPromoBanner',
  showHeader: boolean | null,
  headerTitle: string | null,
  headerSubline: string | null,
  personName: string | null,
  personRole: string | null,
  quote: string | null,
  image: PromoBanner_image | null,
  signature: PromoBanner_signature | null,
  sys: PromoBanner_sys
};

export type Page_page_bodyCollection_items_ComponentRichText = {
  __typename: 'ComponentRichText',
  highlight: string | null,
  title: string | null,
  text: string | null,
  theme: string | null,
  richText: RichText_richText | null,
  c2A: RichText_c2A | null,
  sys: RichText_sys
};

export type Page_page_bodyCollection_items_ComponentStructuredData = {
  __typename: 'ComponentStructuredData',
  structuredData: any,
  sys: StructuredData_sys
};

export type Page_page_bodyCollection_items_ComponentTextAndList = {
  __typename: 'ComponentTextAndList',
  highlight: string | null,
  title: string | null,
  intro: string | null,
  text: string | null,
  theme: string | null,
  layout: boolean | null,
  listLayout: boolean | null,
  listStyle: string | null,
  list: Array<string | null> | null,
  listItemsCollection: TextAndList_listItemsCollection | null,
  c2A: TextAndList_c2A | null,
  sys: TextAndList_sys
};

export type Page_page_bodyCollection_items_ComponentTextAndMedia = {
  __typename: 'ComponentTextAndMedia',
  highlight: string | null,
  title: string | null,
  intro: string | null,
  text: string | null,
  theme: string | null,
  layout: boolean | null,
  listLayout: boolean | null,
  listStyle: string | null,
  listItemsCollection: Cards_cardsCollection_items_ComponentTextAndMedia_listItemsCollection | null,
  c2A: Cards_cardsCollection_items_ComponentTextAndMedia_c2A | null,
  media: Cards_cardsCollection_items_ComponentTextAndMedia_media | null,
  sys: Cards_cardsCollection_items_ComponentTextAndMedia_sys
};

export type Page_page_bodyCollection_items_ComponentTextAndMediaCarousel = {
  __typename: 'ComponentTextAndMediaCarousel',
  sys: TextAndMediaCarousel_sys,
  textAndMediaItemsCollection: TextAndMediaCarousel_textAndMediaItemsCollection | null
};

export type Page_page_bodyCollection_items_ComponentTextAndText = {
  __typename: 'ComponentTextAndText',
  leftHighlight: string | null,
  leftTitle: string | null,
  leftText: string | null,
  rightHighlight: string | null,
  rightTitle: string | null,
  rightText: string | null,
  sys: TextAndText_sys
};

export type Page_page_bodyCollection_items_VariantContainer = {
  __typename: 'VariantContainer',
  experimentId: string | null,
  meta: any,
  variantsCollection: VariantContainer_variantsCollection | null,
  sys: VariantContainer_sys
};

export type Page_page_bodyCollection_items =
  | Page_page_bodyCollection_items_Component
  | Page_page_bodyCollection_items_ComponentBenefits
  | Page_page_bodyCollection_items_ComponentCards
  | Page_page_bodyCollection_items_ComponentFaq
  | Page_page_bodyCollection_items_ComponentHero
  | Page_page_bodyCollection_items_ComponentPackages
  | Page_page_bodyCollection_items_ComponentPromoBanner
  | Page_page_bodyCollection_items_ComponentRichText
  | Page_page_bodyCollection_items_ComponentStructuredData
  | Page_page_bodyCollection_items_ComponentTextAndList
  | Page_page_bodyCollection_items_ComponentTextAndMedia
  | Page_page_bodyCollection_items_ComponentTextAndMediaCarousel
  | Page_page_bodyCollection_items_ComponentTextAndText
  | Page_page_bodyCollection_items_VariantContainer
;

export type Page_page_bodyCollection = {
  __typename: 'PageBodyCollection',
  items: Array<Page_page_bodyCollection_items | null>
};

export type Page_page_banner_sys = {
  __typename: 'Sys',
  id: string
};

export type Page_page_banner = {
  __typename: 'ComponentBanner',
  text: string | null,
  linkText: string | null,
  linkHref: string | null,
  sys: Page_page_banner_sys
};

export type Page_page_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any,
  firstPublishedAt: any
};

export type Page_page = {
  __typename: 'Page',
  internalName: string | null,
  title: string | null,
  slug: string | null,
  seoTitle: string | null,
  seoDescription: string | null,
  seoKeywords: Array<string | null> | null,
  seoNoIndex: boolean | null,
  seoNoFollow: boolean | null,
  content: Page_page_content | null,
  bodyCollection: Page_page_bodyCollection | null,
  banner: Page_page_banner | null,
  sys: Page_page_sys
};

export type Page = {
  page: Page_page | null
};


export type PageVariables = Exact<{
  id: string;
  locale: string;
  preview?: boolean | null;
}>;

export type ArticleData_articleCollection_items_sys = {
  __typename: 'Sys',
  id: string,
  publishedAt: any,
  firstPublishedAt: any
};

export type ArticleData_articleCollection_items_author = {
  __typename: 'Author',
  name: string | null
};

export type ArticleData_articleCollection_items_mainImage = {
  __typename: 'Asset',
  contentType: string | null,
  url: string | null,
  description: string | null,
  sys: MediaAsset_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_sys = {
  __typename: 'Sys',
  id: string
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Article = {
  __typename: 'Article',
  uri: string | null,
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Author = {
  __typename: 'Author',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_BreedsArticle = {
  __typename: 'BreedsArticle',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Checklist = {
  __typename: 'Checklist',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ChecklistItem = {
  __typename: 'ChecklistItem',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Component = {
  __typename: 'Component',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentArticleList = {
  __typename: 'ComponentArticleList',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentBanner = {
  __typename: 'ComponentBanner',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentBenefits = {
  __typename: 'ComponentBenefits',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentButton = {
  __typename: 'ComponentButton',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentC2A = {
  __typename: 'ComponentC2A',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentCards = {
  __typename: 'ComponentCards',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentColumn = {
  __typename: 'ComponentColumn',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentColumns = {
  __typename: 'ComponentColumns',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentFactBlock = {
  __typename: 'ComponentFactBlock',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentFaq = {
  __typename: 'ComponentFaq',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentFirstVetCard = {
  __typename: 'ComponentFirstVetCard',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentGutter = {
  __typename: 'ComponentGutter',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentHero = {
  __typename: 'ComponentHero',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentList = {
  __typename: 'ComponentList',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentPackages = {
  __typename: 'ComponentPackages',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentPromoBanner = {
  __typename: 'ComponentPromoBanner',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentRichText = {
  __typename: 'ComponentRichText',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentStructuredData = {
  __typename: 'ComponentStructuredData',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentTextAndList = {
  __typename: 'ComponentTextAndList',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentTextAndMedia = {
  __typename: 'ComponentTextAndMedia',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentTextAndMediaCarousel = {
  __typename: 'ComponentTextAndMediaCarousel',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentTextAndText = {
  __typename: 'ComponentTextAndText',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ContentfulBreed = {
  __typename: 'ContentfulBreed',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ContentfulTask = {
  __typename: 'ContentfulTask',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Course = {
  __typename: 'Course',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_CourseSection = {
  __typename: 'CourseSection',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_DailyContent = {
  __typename: 'DailyContent',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_FaqItem = {
  __typename: 'FaqItem',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Image = {
  __typename: 'Image',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_KnowledgeScreen = {
  __typename: 'KnowledgeScreen',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ListItem = {
  __typename: 'ListItem',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_NavigationItem = {
  __typename: 'NavigationItem',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Page = {
  __typename: 'Page',
  slug: string | null,
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_PageContent = {
  __typename: 'PageContent',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Quiz = {
  __typename: 'Quiz',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_QuizQuestion = {
  __typename: 'QuizQuestion',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Redirect = {
  __typename: 'Redirect',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_ReferralDiscount = {
  __typename: 'ReferralDiscount',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Site = {
  __typename: 'Site',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Species = {
  __typename: 'Species',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Topic = {
  __typename: 'Topic',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Track = {
  __typename: 'Track',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Url = {
  __typename: 'Url',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_VariantContainer = {
  __typename: 'VariantContainer',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_Video = {
  __typename: 'Video',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink_WeeklyArticlesList = {
  __typename: 'WeeklyArticlesList',
  sys: ArticleData_articleCollection_items_content_links_entries_hyperlink_sys
};

export type ArticleData_articleCollection_items_content_links_entries_hyperlink =
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Article
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Author
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_BreedsArticle
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Checklist
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ChecklistItem
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Component
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentArticleList
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentBanner
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentBenefits
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentButton
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentC2A
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentCards
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentColumn
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentColumns
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentFactBlock
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentFaq
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentFirstVetCard
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentGutter
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentHero
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentList
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentPackages
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentPromoBanner
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentRichText
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentStructuredData
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentTextAndList
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentTextAndMedia
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentTextAndMediaCarousel
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ComponentTextAndText
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ContentfulBreed
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ContentfulTask
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Course
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_CourseSection
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_DailyContent
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_FaqItem
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Image
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_KnowledgeScreen
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ListItem
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_NavigationItem
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Page
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_PageContent
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Quiz
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_QuizQuestion
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Redirect
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_ReferralDiscount
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Site
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Species
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Topic
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Track
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Url
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_VariantContainer
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_Video
  | ArticleData_articleCollection_items_content_links_entries_hyperlink_WeeklyArticlesList
;

export type ArticleData_articleCollection_items_content_links_entries = {
  __typename: 'ArticleContentEntries',
  hyperlink: Array<ArticleData_articleCollection_items_content_links_entries_hyperlink | null>
};

export type ArticleData_articleCollection_items_content_links_assets_block_sys = {
  __typename: 'Sys',
  id: string
};

export type ArticleData_articleCollection_items_content_links_assets_block = {
  __typename: 'Asset',
  url: string | null,
  contentType: string | null,
  description: string | null,
  width: number | null,
  height: number | null,
  sys: ArticleData_articleCollection_items_content_links_assets_block_sys
};

export type ArticleData_articleCollection_items_content_links_assets = {
  __typename: 'ArticleContentAssets',
  block: Array<ArticleData_articleCollection_items_content_links_assets_block | null>
};

export type ArticleData_articleCollection_items_content_links = {
  __typename: 'ArticleContentLinks',
  entries: ArticleData_articleCollection_items_content_links_entries,
  assets: ArticleData_articleCollection_items_content_links_assets
};

export type ArticleData_articleCollection_items_content = {
  __typename: 'ArticleContent',
  json: any,
  links: ArticleData_articleCollection_items_content_links
};

export type ArticleData_articleCollection_items_video = {
  __typename: 'Video',
  mux: any
};

export type ArticleData_articleCollection_items_species = {
  __typename: 'Species',
  code: string | null
};

export type ArticleData_articleCollection_items_topicsCollection_items_sys = {
  __typename: 'Sys',
  id: string
};

export type ArticleData_articleCollection_items_topicsCollection_items = {
  __typename: 'Topic',
  name: string | null,
  sys: ArticleData_articleCollection_items_topicsCollection_items_sys
};

export type ArticleData_articleCollection_items_topicsCollection = {
  __typename: 'ArticleTopicsCollection',
  items: Array<ArticleData_articleCollection_items_topicsCollection_items | null>
};

export type ArticleData_articleCollection_items = {
  __typename: 'Article',
  org: Array<string | null> | null,
  uri: string | null,
  title: string | null,
  metadataTitle: string | null,
  seoDescription: string | null,
  shortText: string | null,
  sys: ArticleData_articleCollection_items_sys,
  author: ArticleData_articleCollection_items_author | null,
  mainImage: ArticleData_articleCollection_items_mainImage | null,
  content: ArticleData_articleCollection_items_content | null,
  video: ArticleData_articleCollection_items_video | null,
  species: ArticleData_articleCollection_items_species | null,
  topicsCollection: ArticleData_articleCollection_items_topicsCollection | null
};

export type ArticleData_articleCollection = {
  __typename: 'ArticleCollection',
  items: Array<ArticleData_articleCollection_items | null>
};

export type ArticleData = {
  articleCollection: ArticleData_articleCollection | null
};


export type ArticleDataVariables = Exact<{
  where?: ArticleFilter | null;
  locale?: string | null;
}>;

export type LatestArticlesData_topicCollection_items_linkedFrom_articleCollection_items = {
  __typename: 'Article',
  org: Array<string | null> | null,
  uri: string | null,
  title: string | null,
  metadataTitle: string | null,
  readTime: number | null,
  shortText: string | null,
  sys: ArticleCardArticle_sys,
  mainImage: ArticleCardArticle_mainImage | null,
  video: ArticleCardArticle_video | null,
  category: ArticleCardArticle_category | null,
  topicsCollection: ArticleCardArticle_topicsCollection | null
};

export type LatestArticlesData_topicCollection_items_linkedFrom_articleCollection = {
  __typename: 'ArticleCollection',
  items: Array<LatestArticlesData_topicCollection_items_linkedFrom_articleCollection_items | null>
};

export type LatestArticlesData_topicCollection_items_linkedFrom = {
  __typename: 'TopicLinkingCollections',
  articleCollection: LatestArticlesData_topicCollection_items_linkedFrom_articleCollection | null
};

export type LatestArticlesData_topicCollection_items = {
  __typename: 'Topic',
  linkedFrom: LatestArticlesData_topicCollection_items_linkedFrom | null
};

export type LatestArticlesData_topicCollection = {
  __typename: 'TopicCollection',
  items: Array<LatestArticlesData_topicCollection_items | null>
};

export type LatestArticlesData = {
  topicCollection: LatestArticlesData_topicCollection | null
};


export type LatestArticlesDataVariables = Exact<{
  where?: TopicFilter | null;
  locale?: string | null;
}>;

export type UseBreedDataList_getBreedDataList = {
  __typename: 'BreedData',
  ids: Array<string>,
  displayNames: Array<string>,
  type: BreedType | null,
  species: SpeciesEnum | null,
  breedGroupId: string | null,
  restrictedFromMarket: boolean | null,
  liabilityInsurable: boolean | null,
  lifeSignupMaxAgeMonths: number | null,
  lifeRenewalMaxAgeMonths: number | null
};

export type UseBreedDataList = {
  getBreedDataList: Array<UseBreedDataList_getBreedDataList> | null
};


export type UseBreedDataListVariables = Exact<{
  input: GetBreedsInput;
}>;

export type GetBreedDataListSignupIndex_getBreedDataList = {
  __typename: 'BreedData',
  ids: Array<string>,
  displayNames: Array<string>
};

export type GetBreedDataListSignupIndex = {
  getBreedDataList: Array<GetBreedDataListSignupIndex_getBreedDataList> | null
};


export type GetBreedDataListSignupIndexVariables = Exact<{
  input: GetBreedsInput;
}>;
